<template>
  <section
    data-cy="ticket-overview"
    :data-view-ready="!loading">
    <div
      v-if="mainReferences.length > 0"
      class="row mb-2">
      <div class="col-12 col-md-2 offset-10">
        <coozzy-button
          design="prop-green"
          class="w-100 sort"
          data-cy="ticket-create-btn"
          @click="$emit('create-ticket')">
          {{ $t('message.ticketOverview.createTicket') }}
        </coozzy-button>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-12 col-md-2 mb-2">
        <coozzy-form-input
          ref="searchText"
          v-model="searchText"
          data-cy="ticket-input-search"
          :placeholder="$t('message.generic.search')"
          @input="searchInputText" />
      </div>
      <div class="col-12 col-md-2 mb-2 pr-md-0">
        <div class="row">
          <div class="col-6 pl-0">
            <coozzy-multiselect
              v-model="searchPriority"
              data-cy="ticket-select-priority"
              class="filter-inputs"
              :options="availablePriorityOptions"
              :multiple="true"
              :placeholder="$tc('message.ticketOverview.ticket.priority.title')"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :taggable="false"
              :custom-label="customLabelPriority" />
          </div>
          <div class="col-6">
            <coozzy-multiselect
              v-model="searchType"
              data-cy="ticket-select-type"
              class="filter-inputs"
              :options="availableTypeOptions"
              :multiple="true"
              :costum-class="'pl-0'"
              :placeholder="$tc('message.ticketOverview.ticket.type.title')"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :custom-label="customLabelType"
              :taggable="false" />
          </div>
        </div>
      </div>
      <div
        v-if="isFromProperty && fromHistory"
        class="col-12 col-md-2 mb-2 pr-md-0"
        :class="!closedTicket ? 'pr-md-0' : ''">
        <!--     Building Filter     -->
        <coozzy-multiselect
          v-model="searchBuilding"
          data-cy="ticket-select-building"
          class="filter-inputs"
          :options="filtredBuildingOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.building')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :track-by="'id'"
          :label="'name'" />
      </div>
      <div
        v-if="mainReferences.length"
        class="col-12 col-md-2 mb-2"
        :class="!closedTicket ? 'pr-md-0' : ''">
        <!--     Object Filter     -->
        <coozzy-multiselect
          v-model="searchObject"
          data-cy="ticket-select-object"
          class="filter-inputs"
          :options="filtredObjectOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.object')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :track-by="'id'"
          :label="'name'" />
      </div>
      <div
        v-if="deviceList && mainReferences.length > 0"
        class="col-12 col-md-2 mb-2 pr-md-0">
        <coozzy-multiselect
          v-model="searchDevice"
          data-cy="ticket-select-device"
          class="filter-inputs"
          :options="deviceList"
          :multiple="true"
          :placeholder="$tc('message.onBoarding.devices.type')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :track-by="'value'"
          :preselect-first="false"
          :taggable="false"
          :custom-label="customLabelDevice" />
      </div>
      <div
        class="col-12 col-md-2 mb-2"
        :class="!fromHistory || (fromHistory && !isFromProperty) ? 'pr-md-0' : ''">
        <coozzy-assignee-multiselect
          v-model="searchAssignee"
          data-cy="ticket-select-assignee"
          class="filter-inputs"
          :options="employeeFilteredList"
          :multiple="true"
          :placeholder="$tc('message.tableColumnHeadings.assignee')"
          :close-on-select="false"
          :clear-on-select="true"
          :preserve-search="false"
          :include-unassigned="true"
          :custom-label="customLabelEmployee"
          :html-label="assigneeHtmlLabel"
          :track-by="'value'"
          :preselect-first="false"
          :taggable="false" />
      </div>
      <div
        v-if="mainReferences.length === 0 && !closedTicket"
        class="col-12 col-md-4">
        <div class="row">
          <div
            v-if="mainReferences.length === 0"
            class="col pr-md-0"
            :class="!closedTicket ? 'mb-2' : ''">
            <coozzy-form-checkbox
              v-if="!closedTicket"
              v-model="searchDueDate"
              data-cy="ticket-checkbox-overdue"
              :initial="searchDueDate"
              :class="'p-0 w-100 as-button'"
              name="searchDueDate"
              button>
              {{ $t('message.ticketOverview.ticket.overdueTicket') }}
            </coozzy-form-checkbox>
          </div>
          <div
            v-if="mainReferences.length === 0"
            class="col pr-md-0"
            :class="!closedTicket ? 'mb-2' : ''">
            <coozzy-form-checkbox
              v-if="!closedTicket"
              v-model="searchWatcher"
              data-cy="ticket-checkbox-watched"
              :initial="searchWatcher"
              :class="'p-0 w-100 as-button'"
              name="searchWatcher"
              button>
              {{ $t('message.ticketOverview.ticket.watchedByMe') }}
            </coozzy-form-checkbox>
          </div>
          <div
            v-if="mainReferences.length === 0"
            class="col pr-md-0"
            :class="!closedTicket ? 'mb-2' : ''">
            <coozzy-form-checkbox
              v-if="!closedTicket"
              v-model="searchNewEvent"
              data-cy="ticket-checkbox-new-event"
              :initial="searchNewEvent"
              :class="'p-0 w-100 as-button'"
              name="searchNewEvent"
              button>
              {{ $t('message.ticketOverview.ticket.newEvent') }}
            </coozzy-form-checkbox>
          </div>
          <div
            v-if="mainReferences.length === 0"
            class="col pr-md-0"
            :class="!closedTicket ? 'mb-2' : ''">
            <coozzy-form-checkbox
              v-if="!closedTicket"
              v-model="searchUploadedInvoice"
              data-cy="ticket-checkbox-uploaded-invoice"
              :initial="searchUploadedInvoice"
              :class="'p-0 w-100 as-button'"
              name="searchUploadedInvoice"
              button>
              {{ $t('message.ticketOverview.ticket.uploadInvoice.uploadedInvoice') }}
            </coozzy-form-checkbox>
          </div>
        </div>
      </div>
      <div
        v-if="mainReferences.length === 0"
        class="col-12 col-md-2 mb-2"
        :class="closedTicket ? 'pr-md-0' : ''">
        <!--     Owner Filter     -->
        <coozzy-multiselect
          v-model="searchOwner"
          data-cy="ticket-select-owner"
          class="filter-inputs"
          :options="availableOwnerOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.owner')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :track-by="'value'"
          :custom-label="customLabelEstate" />
      </div>
      <div
        v-if="mainReferences.length === 0"
        class="col-12 col-md-2 mb-2">
        <!--     Property Filter     -->
        <coozzy-multiselect
          v-model="searchProperty"
          data-cy="ticket-select-property"
          class="filter-inputs"
          :options="filtredPropertyOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.property')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :track-by="'id'"
          :taggable="false"
          :label="'name'" />
      </div>
      <div
        v-if="mainReferences.length === 0"
        class="col-12 col-md-2 mb-2 pl-md-0"
        :class="!closedTicket ? 'pr-md-0' : ''">
        <!--     Building Filter     -->
        <coozzy-multiselect
          v-model="searchBuilding"
          data-cy="ticket-select-building"
          class="filter-inputs"
          :options="filtredBuildingOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.building')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :track-by="'id'"
          :label="'name'" />
      </div>
      <div
        v-if="mainReferences.length === 0"
        class="col-12 col-md-2 mb-2"
        :class="!closedTicket ? 'pr-md-0' : ''">
        <!--     Object Filter     -->
        <coozzy-multiselect
          v-model="searchObject"
          data-cy="ticket-select-object"
          class="filter-inputs"
          :options="filtredObjectOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.object')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :track-by="'id'"
          :label="'name'" />
      </div>
      <div
        v-if="mainReferences.length === 0"
        class="col-12 col-md-2 mb-2"
        :class="closedTicket ? 'pr-md-0 pl-md-0' : 'pr-md-0'">
        <!--     Operator Filter     -->
        <contact-search-select
          v-model="involvedPeople"
          data-cy="ticket-select-involved-people"
          :filters="contactSearchFiltersOperator"
          :transform-hits="filterHitsWithObjectId"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.filters.involvedPeople')"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          track-by="objectID"
          label="name"
          :custom-label="customLabelOperator" />
      </div>
      <div
        class="col-12 col-md-2 mb-2"
        :class="!fromHistory ? 'pr-md-0' : ''">
        <coozzy-multiselect-html-option
          v-model="searchCreator"
          data-cy="ticket-select-creator"
          class="filter-inputs"
          :options="employeeFilteredListWithSystem"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.ticket.creator')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :custom-label="customLabelEmployee"
          :html-label="customLabelEmployee"
          :track-by="'value'"
          :preselect-first="false"
          :taggable="false" />
      </div>
      <div
        class="col-12 col-md-2 mb-2 mb-2"
        :class="isFromProperty ? 'p-0' : closedTicket ? 'pr-md-0' : ''">
        <coozzy-multiselect
          v-model="searchStatus"
          data-cy="ticket-select-status"
          class="filter-inputs"
          :options="filtredAvailableStatusOptions"
          :multiple="true"
          :placeholder="$tc('message.ticketOverview.status.title')"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :custom-label="customLabelStatus"
          :taggable="false" />
      </div>
      <div
        v-if="mainReferences.length !== 0"
        :class="!isColumnView ? '' : 'offset-md-6'"
        class="col-12 col-md-2 pr-md-0">
        <coozzy-form-checkbox
          v-if="mainReferences.length > 0 && mainReferences[0].startsWith('prop')"
          v-model="showEntireProperty"
          data-cy="ticket-checkbox-show-entire-property"
          :initial="showEntireProperty"
          :class="'width-fit-content'"
          name="searchDueDate">
          {{ $t('message.ticketOverview.ticket.showEntireProperty') }}
        </coozzy-form-checkbox>
      </div>
    </div>
    <div
      v-if="loading"
      class="row">
      <div class="col text-center">
        <coozzy-spinner class="m-3" />
      </div>
    </div>
    <div v-else>
      <div v-if="isColumnView">
        <!-- Ticket columns -->
        <div
          id="parent"
          data-cy="ticket-board"
          class="row mt-1">
          <!-- Open columns -->
          <div
            class="col-12 col-md-4"
            data-cy="ticket-column-open">
            <h4 class="column-heading rounded p-2">
              {{ $tc('message.ticketOverview.status.TICKET_STATUS_OPEN') }} ({{ sortedOpenTicket.length }})
            </h4>
            <div
              class="column-container rounded p-1"
              :class="draggingOver === 'open' ? 'dragging-border' : ''"
              @dragover.prevent="onColumnDragOver($event, 'open')"
              @dragleave="onColumnDragLeave($event, 'open')"
              @drop.prevent="onColumnDrop($event, 'open')">
              <h6
                v-if="!dragging && sortedOpenTicket.length === 0"
                class="text-center text-grey p-3">
                {{ $t('message.ticketOverview.noTickets') }}
              </h6>

              <dynamic-scroller
                id="status-open"
                ref="openScroller"
                :items="sortedOpenTicket"
                :min-item-size="170"
                :buffer="openScrollerBuffer"
                key-field="id"
                page-mode>
                <template #default="{ item: element, index, active }">
                  <dynamic-scroller-item
                    :item="element"
                    :active="active"
                    :data-index="index">
                    <div
                      class="ticket-item"
                      :draggable="isTicketingEnabled && (isEditor || isTicketEditor)"
                      @dragstart="onTicketDragStart($event, element, 'open')"
                      @dragend="onTicketDragEnd">
                      <ticket-card
                        :ticket="element"
                        :mail="isTicketReferenceInMail(element)"
                        @click="openDetail"
                        @click-middle="openMiddleDetail">
                        <!-- slot of connection -->
                        <div class="col-12 d-flex">
                          <div class="mr-1">
                            {{ $t('message.ticketOverview.ticket.connections') }}:
                          </div>
                          <span v-if="element.references.length === 0"> - </span>
                          <div>
                            <template v-for="ref in element.references">
                              <p
                                v-if="ref.id"
                                :key="ref.id"
                                class="mb-0">
                                <span
                                  v-if="ref.id.startsWith('ins') && computedAllConnections.insurances"
                                  class="external-link">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && allConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && allConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && allConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setInsuranceId(getConnection(ref.id), false)"
                                    @click.middle="setInsuranceId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id).type) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id)?.type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span
                                  v-if="ref.id.startsWith('mortgage') && computedAllConnections.mortgages"
                                  class="external-link">
                                  <span
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setMortgageId(getConnection(ref.id), false)"
                                    @click.middle="setMortgageId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('device') && computedAllConnections.devices">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findObjectConnectionId(ref) && computedAllConnections.objects">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findObjectConnectionId(ref)) !== undefined ? redirectToDetailPage(getConnection(findObjectConnectionId(ref)), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </span>
                                    >
                                  </span>
                                  <span v-if="getDeviceRoom(ref)">
                                    <a
                                      v-if="!isMarketingModule"
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id)"
                                      @mousedown.middle.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id, true)">
                                      {{ getDeviceRoom(ref).name }}
                                    </a>
                                    <template v-else>{{ getDeviceRoom(ref).name }}</template>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDeviceDetail(getConnection(ref.id)) : ''">
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('obj') && computedAllConnections.objects">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'obj') : ''">
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </router-link>
                                  <span v-else>
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('building') && computedAllConnections.buildings">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'building') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('prop') && computedAllConnections.properties">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'prop') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('contact') && computedAllConnections.contacts">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'contact') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('request')">
                                  <router-link
                                    v-if="getConnection(ref.id)?.requesters?.length > 0"
                                    class="external-link"
                                    :to="redirectToRequestDetail(getConnection(ref.id)?.objectId, ref.id)">
                                    {{ getContactName(getConnection(ref.id)?.requesters?.[0]?.contactId) }}
                                  </router-link>
                                </span>
                                <span v-if="ref.id.startsWith('tenancy')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'tenants') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('condo')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'condominium') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('room')">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && computedAllConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span v-if="!isMarketingModule">
                                    >
                                    <a
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getConnection(ref.id), ref.id)"
                                      @mousedown.middle.prevent="navigateToRoom(getConnection(ref.id), ref.id, true)">
                                      {{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}
                                    </a>
                                  </span>
                                  <span v-else>{{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}</span>
                                </span>
                              </p>
                              <p
                                v-else
                                :key="'else-open-' + ref.id">
                                -
                              </p>
                            </template>
                          </div>
                        </div>
                      </ticket-card>
                    </div>
                  </dynamic-scroller-item>
                </template>
              </dynamic-scroller>
            </div>
          </div>
          <!-- In progress column -->
          <div
            class="col-12 col-md-4 mt-5 mt-md-0"
            data-cy="ticket-column-in-progress">
            <h4 class="column-heading rounded p-2">
              {{ $t('message.ticketOverview.status.TICKET_STATUS_IN_PROGRESS') }} ({{ sortedProgressTicket.length }})
            </h4>
            <div
              class="column-container rounded p-1"
              :class="draggingOver === 'in_progress' ? 'dragging-border' : ''"
              @dragover.prevent="onColumnDragOver($event, 'in_progress')"
              @dragleave="onColumnDragLeave($event, 'in_progress')"
              @drop.prevent="onColumnDrop($event, 'in_progress')">
              <h6
                v-if="!dragging && sortedProgressTicket.length === 0"
                class="text-center text-grey p-3">
                {{ $t('message.ticketOverview.noTickets') }}
              </h6>

              <dynamic-scroller
                id="status-progress"
                ref="progressScroller"
                :items="sortedProgressTicket"
                :min-item-size="170"
                :buffer="progressScrollerBuffer"
                key-field="id"
                page-mode>
                <template #default="{ item: element, index, active }">
                  <dynamic-scroller-item
                    :item="element"
                    :active="active"
                    :data-index="index">
                    <div
                      class="ticket-item"
                      :draggable="isTicketingEnabled && (isEditor || isTicketEditor)"
                      @dragstart="onTicketDragStart($event, element, 'in_progress')"
                      @dragend="onTicketDragEnd">
                      <ticket-card
                        :ticket="element"
                        :mail="isTicketReferenceInMail(element)"
                        @click="openDetail"
                        @click-middle="openMiddleDetail">
                        <!-- slot of connection -->
                        <div class="col-12 d-flex">
                          <div class="mr-1">
                            {{ $t('message.ticketOverview.ticket.connections') }}:
                          </div>
                          <span v-if="element.references.length === 0"> - </span>
                          <div>
                            <template v-for="ref in element.references">
                              <p
                                v-if="ref.id"
                                :key="ref.id"
                                class="mb-0">
                                <span
                                  v-if="ref.id.startsWith('ins') && computedAllConnections.insurances"
                                  class="external-link">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && computedAllConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setInsuranceId(getConnection(ref.id), false)"
                                    @click.middle="setInsuranceId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id).type) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id)?.type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span
                                  v-if="ref.id.startsWith('mortgage') && computedAllConnections.mortgages"
                                  class="external-link">
                                  <a
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setMortgageId(getConnection(ref.id), false)"
                                    @click.middle="setMortgageId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </a>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('device') && computedAllConnections.devices">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findObjectConnectionId(ref) && computedAllConnections.objects">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findObjectConnectionId(ref)) !== undefined ? redirectToDetailPage(getConnection(findObjectConnectionId(ref)), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </span>
                                    >
                                  </span>
                                  <span v-if="getDeviceRoom(ref)">
                                    <a
                                      v-if="!isMarketingModule"
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id)"
                                      @mousedown.middle.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id, true)">
                                      {{ getDeviceRoom(ref).name }}
                                    </a>
                                    <template v-else>{{ getDeviceRoom(ref).name }}</template>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDeviceDetail(getConnection(ref.id)) : ''">
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('obj') && computedAllConnections.objects">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'obj') : ''">
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </router-link>
                                  <span v-else>
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('building') && computedAllConnections.buildings">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'building') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('prop') && computedAllConnections.properties">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'prop') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('contact') && computedAllConnections.contacts">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'contact') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('request')">
                                  <router-link
                                    v-if="getConnection(ref.id)?.requesters?.length > 0"
                                    class="external-link"
                                    :to="redirectToRequestDetail(ref.objectId, ref.id)">
                                    {{ getContactName(getConnection(ref.id)?.requesters?.[0]?.contactId) }}
                                  </router-link>
                                </span>
                                <span v-if="ref.id.startsWith('tenancy')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'tenants') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('condo')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'condominium') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('room')">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && computedAllConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span v-if="!isMarketingModule">
                                    >
                                    <a
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getConnection(ref.id), ref.id)"
                                      @mousedown.middle.prevent="navigateToRoom(getConnection(ref.id), ref.id, true)">
                                      {{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}
                                    </a>
                                  </span>
                                  <span v-else>{{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}</span>
                                </span>
                              </p>
                              <p
                                v-else
                                :key="'else-inprogress-' + ref.id">
                                -
                              </p>
                            </template>
                          </div>
                        </div>
                      </ticket-card>
                    </div>
                  </dynamic-scroller-item>
                </template>
              </dynamic-scroller>
            </div>
          </div>

          <!-- Done column -->
          <div
            class="col-12 col-md-4 mt-5 mt-md-0"
            data-cy="ticket-column-done">
            <h4 class="column-heading rounded p-2">
              {{ $t('message.ticketOverview.status.TICKET_STATUS_DONE') }} ({{ sortedDoneTicket.length }})
            </h4>
            <div
              class="column-container rounded p-1"
              :class="draggingOver === 'done' ? 'dragging-border' : ''"
              @dragover.prevent="onColumnDragOver($event, 'done')"
              @dragleave="onColumnDragLeave($event, 'done')"
              @drop.prevent="onColumnDrop($event, 'done')">
              <h6
                v-if="!dragging && sortedDoneTicket.length === 0"
                class="text-center text-grey p-3">
                {{ $t('message.ticketOverview.noTickets') }}
              </h6>

              <dynamic-scroller
                id="status-done"
                ref="doneScroller"
                :items="sortedDoneTicket"
                :min-item-size="170"
                :buffer="doneScrollerBuffer"
                key-field="id"
                page-mode>
                <template #default="{ item: element, index, active }">
                  <dynamic-scroller-item
                    :item="element"
                    :active="active"
                    :data-index="index">
                    <div
                      class="ticket-item"
                      :draggable="isTicketingEnabled && (isEditor || isTicketEditor)"
                      @dragstart="onTicketDragStart($event, element, 'done')"
                      @dragend="onTicketDragEnd">
                      <ticket-card
                        :ticket="element"
                        :mail="isTicketReferenceInMail(element)"
                        @click="openDetail"
                        @click-middle="openMiddleDetail">
                        <!-- slot of connection -->
                        <div class="col-12 d-flex">
                          <div class="mr-1">
                            {{ $t('message.ticketOverview.ticket.connections') }} :
                          </div>
                          <span v-if="element.references.length === 0"> - </span>
                          <div>
                            <template v-for="ref in element.references">
                              <p
                                v-if="ref.id"
                                :key="ref.id"
                                class="mb-0">
                                <span
                                  v-if="ref.id.startsWith('ins') && computedAllConnections.insurances"
                                  class="external-link">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && computedAllConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setInsuranceId(getConnection(ref.id), false)"
                                    @click.middle="setInsuranceId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id).type) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id)?.type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span
                                  v-if="ref.id.startsWith('mortgage') && computedAllConnections.mortgages"
                                  class="external-link">
                                  <a
                                    v-if="!isMarketingModule"
                                    class="external-link link"
                                    @click="setMortgageId(getConnection(ref.id), false)"
                                    @click.middle="setMortgageId(getConnection(ref.id), true)">
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                      <template v-if="getReferenceName(ref.id) !== ''">
                                        {{ ' - ' + getReferenceName(ref.id) }}
                                      </template>
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </a>
                                  <span v-else>
                                    <template v-if="getConnection(ref.id)">
                                      {{ getConnection(ref.id).bankName + ' - ' +
                                        $t('message.onBoarding.mortgage.mortgageDesignation.' +
                                          getConnection(ref.id).mortgageDesignation) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('device') && computedAllConnections.devices">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findObjectConnectionId(ref) && computedAllConnections.objects">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findObjectConnectionId(ref)) !== undefined ? redirectToDetailPage(getConnection(findObjectConnectionId(ref)), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) }}
                                    </span>
                                    >
                                  </span>
                                  <span v-if="getDeviceRoom(ref)">
                                    <a
                                      v-if="!isMarketingModule"
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id)"
                                      @mousedown.middle.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id, true)">
                                      {{ getDeviceRoom(ref).name }}
                                    </a>
                                    <template v-else>{{ getDeviceRoom(ref).name }}</template>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDeviceDetail(getConnection(ref.id)) : ''">
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template
                                      v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                                      {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                                    </template>
                                    <template v-else>
                                      -
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('obj') && computedAllConnections.objects">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) ? redirectToDetailPage(getConnection(ref.id), 'obj') : ''">
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </router-link>
                                  <span v-else>
                                    {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('building') && computedAllConnections.buildings">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                    >
                                  </span>
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'building') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('prop') && computedAllConnections.properties">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'prop') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('contact') && computedAllConnections.contacts">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'contact') : ''">
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </router-link>
                                  <span v-else>
                                    {{ getConnection(ref.id)?.name || '' }}
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('request')">
                                  <router-link
                                    v-if="getConnection(ref.id)?.requesters?.length > 0"
                                    class="external-link"
                                    :to="redirectToRequestDetail(ref.objectId, ref.id)">
                                    {{ getContactName(getConnection(ref.id)?.requesters?.[0]?.contactId) }}
                                  </router-link>
                                </span>
                                <span v-if="ref.id.startsWith('tenancy')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'tenants') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('condo')">
                                  <router-link
                                    v-if="!isMarketingModule"
                                    class="external-link"
                                    :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'condominium') : ''">
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </router-link>
                                  <span v-else>
                                    <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                                      {{ getContactName(contact) }}
                                    </template>
                                  </span>
                                </span>
                                <span v-if="ref.id.startsWith('room')">
                                  <span
                                    v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'prop')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop') : ''">
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'prop'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'building')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building') : ''">
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </router-link>
                                    <span v-else>
                                      {{ getConnection(findConnectionId(ref, 'building'))?.name || '' }}
                                    </span>
                                  </span>
                                  <span
                                    v-if="findConnectionId(ref, 'obj') && computedAllConnections.objects">
                                    >
                                    <router-link
                                      v-if="!isMarketingModule"
                                      class="external-link"
                                      :to="getConnection(findConnectionId(ref, 'obj')) !== undefined ? redirectToDetailPage(getConnection(findConnectionId(ref, 'obj')), 'obj') : ''">
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </router-link>
                                    <span v-else>
                                      {{ getObjectConnectionLabel(getConnection(findConnectionId(ref, 'obj'))) }}
                                    </span>
                                  </span>
                                  <span v-if="!isMarketingModule">
                                    >
                                    <a
                                      class="external-link cursor-pointer"
                                      href="#"
                                      @click.prevent="navigateToRoom(getConnection(ref.id), ref.id)"
                                      @mousedown.middle.prevent="navigateToRoom(getConnection(ref.id), ref.id, true)">
                                      {{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}
                                    </a>
                                  </span>
                                  <span v-else>{{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}</span>
                                </span>
                              </p>
                              <p
                                v-else
                                :key="'else-done-' + ref.id">
                                -
                              </p>
                            </template>
                          </div>
                        </div>
                      </ticket-card>
                    </div>
                  </dynamic-scroller-item>
                </template>
              </dynamic-scroller>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        id="rowConfig"
        class="row overflow-auto align-items-center">
        <div class="col-md-2 col-sm-6 col-12">
          <coozzy-dropdown
            design="green"
            size="sm"
            class="w-100"
            data-cy="ticket-btn-selected-actions"
            :text="selectedEntriesText">
            <template v-if="!draftTicket">
              <coozzy-dropdown-item
                data-cy="ticket-action-change-assignee"
                :disabled="selectedEntries.length === 0"
                @click="showModalChangeAssignee()">
                {{ $t('message.ticketOverview.changeAssignee') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                data-cy="ticket-action-change-watchers"
                :disabled="selectedEntries.length === 0"
                @click="showModalChangeWatchers()">
                {{ $t('message.ticketOverview.startWatching') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                data-cy="ticket-action-change-status"
                :disabled="selectedEntries.length === 0"
                @click="showModalChangeStatus()">
                {{ $t('message.ticketOverview.changeStatusModal.title') }}
              </coozzy-dropdown-item>
            </template>
            <coozzy-dropdown-item
              v-else
              data-cy="ticket-action-delete"
              :disabled="selectedEntries.length === 0"
              @click="deleteTicketClicked">
              {{ $t('message.generic.delete') }}
            </coozzy-dropdown-item>
            <div
              v-if="draftTicket"
              class="row m-0 align-items-center"
              :class="selectedEntries.length === 0 ? 'coozzyDropdownItemTooltip' : 'dropdownOptionHover'">
              <coozzy-dropdown-item
                data-cy="ticket-action-merge-orders"
                :disabled="selectedEntries.length === 0 || !onlyOrdersSelected"
                @click="mergeOrders">
                {{ $t('message.ticketOverview.ticket.actions.mergeOrders') }}
              </coozzy-dropdown-item>
              <div class="pl-2 pr-2">
                <coozzy-info-circle-icon
                  v-b-tooltip.hover.html="$t('message.ticketOverview.ticket.mergeOrders.tooltip')" />
              </div>
            </div>
            <report-damage-dropdown-item
              v-if="aicEnabled"
              :properties="[property || properties[0]]"
              :additional-disabled="selectedEntries.length === 0"
              :click-handler="showModalReportDamageInsurance" />
          </coozzy-dropdown>
        </div>
        <div class="col-md-2 col-sm-6 col-12">
          <template v-if="selectAllVisibleEntries && totalTickets > nbrPerPage && totalTickets <= 1000">
            <coozzy-form-checkbox
              v-model="selectAllEntries"
              data-cy="ticket-checkbox-select-all-hidden"
              :initial="selectAllEntries"
              :class="'p-0 w-100 btn-height-auto'"
              name="selectAllEntries"
              button>
              {{ selectAllEntries ? $t('message.generic.unselectHiddenEntries', { amount: totalTickets }) :
                $t('message.generic.selectHiddenEntries', { amount: totalTickets }) }}
            </coozzy-form-checkbox>
          </template>
        </div>
        <!--   Added only for keep the same size   -->

        <div
          v-if="isCompanyAdmin === true && !closedTicket"
          class="offset-md-5 col-md-1 d-flex justify-content-end align-items-center">
          <div
            data-cy="ticket-btn-columns"
            @click="openAssembleListModal()">
            <coozzy-filters-icon
              v-b-tooltip="{container: '#rowConfig', title: $t('message.generic.tooltipAssembleList')}" />
          </div>
        </div>
        <div
          class="col-12 col-md-2"
          :class="closedTicket ? 'offset-md-6' : ''">
          <coozzy-form-select
            v-if="!isColumnView"
            v-model="nbrPerPage"
            data-cy="ticket-select-page-size"
            name="numberEntries">
            <option :value="5">
              5 {{ $t('message.generic.entries') }}
            </option>
            <option :value="10">
              10 {{ $t('message.generic.entries') }}
            </option>
            <option :value="15">
              15 {{ $t('message.generic.entries') }}
            </option>
            <option :value="20">
              20 {{ $t('message.generic.entries') }}
            </option>
            <option :value="50">
              50 {{ $t('message.generic.entries') }}
            </option>
            <option :value="100">
              100 {{ $t('message.generic.entries') }}
            </option>
          </coozzy-form-select>
        </div>
        <div class="col-12 mt-2">
          <b-table
            id="ticketOverviewTable"
            ref="ticketOverviewTable"
            data-cy="ticket-table"
            bordered
            hover
            selectable
            select-mode="single"
            :fields="fields"
            :busy="loading"
            :items="ticketList"
            @row-clicked="showDetail"
            @row-middle-clicked="showDetailMiddle">
            <!-- Headings -->
            <template #head(checkbox)>
              <coozzy-form-checkbox
                ref="header_checkbox"
                data-cy="ticket-checkbox-select-all"
                @change="(value) => { handleCheckboxesInsideTable(value) }" />
            </template>
            <template #head(title)>
              {{ $t('message.tableColumnHeadings.title') }}
            </template>
            <template #head(ticketKey)>
              {{ $t('message.tableColumnHeadings.ticketKey') }}
            </template>
            <template #head(type)>
              {{ $t('message.tableColumnHeadings.type') }}
            </template>
            <template #head(ticketConnections)>
              {{ $t('message.tableColumnHeadings.ticketConnections') }}
            </template>
            <template #head(status)>
              {{ $t('message.tableColumnHeadings.status') }}
            </template>
            <template #head(assignee)>
              {{ $t('message.tableColumnHeadings.assignee') }}
            </template>
            <template #head(ticketPriority)>
              {{ $t('message.tableColumnHeadings.ticketPriority') }}
            </template>
            <template #head(ticketInvoice)>
              {{ $t('message.tableColumnHeadings.ticketInvoice') }}
            </template>
            <template #head(ticketExecuteFrom)>
              {{ $t('message.tableColumnHeadings.ticketExecuteFrom') }}
            </template>
            <template #head(ticketExecuteUntil)>
              {{ $t('message.tableColumnHeadings.ticketExecuteUntil') }}
            </template>
            <template #head(receivedOpened)>
              {{ $t('message.tableColumnHeadings.receivedOpened') }}
            </template>
            <template #head(operator)>
              {{ $t('message.tableColumnHeadings.operator') }}
            </template>
            <template #head(progress)>
              {{ $t('message.tableColumnHeadings.progress') }}
            </template>

            <!-- Columns -->
            <template #cell(checkbox)="data">
              <div>
                <coozzy-form-checkbox
                  :id="'check_' + data.item.id"
                  data-cy="ticket-checkbox-row"
                  @change="(value) => { itemSelected(data.item, value) }" />
              </div>
            </template>
            <template #cell(newEvent)="data">
              <div>
                <img
                  v-if="data.item && data.item.readStatus && !data.item.readStatus.assignee"
                  height="20px"
                  class="ml-3 mb-1"
                  :src="`/img/ticket/notification-bell.svg`"
                  alt="type">
              </div>
            </template>
            <template #cell(status)="data">
              <span data-cy="ticket-row-status">
                <template v-if="data.item.status === 'TICKET_STATUS_OPEN'">
                  {{ $t('message.ticketOverview.status.TICKET_STATUS_OPEN') }}
                </template>
                <template v-else-if="data.item.status === 'TICKET_STATUS_IN_PROGRESS'">
                  {{ $t('message.ticketOverview.status.TICKET_STATUS_IN_PROGRESS') }}
                </template>
                <template v-else-if="data.item.status === 'TICKET_STATUS_DONE'">
                  {{ $t('message.ticketOverview.status.TICKET_STATUS_DONE') }}
                </template>
                <template v-else-if="data.item.status === 'TICKET_STATUS_CLOSED'">
                  {{ $t('message.ticketOverview.status.TICKET_STATUS_CLOSED') }}
                </template>
                <template v-else-if="data.item.status === 'TICKET_STATUS_DRAFT'">
                  {{ $t('message.ticketOverview.status.TICKET_STATUS_DRAFT') }}
                </template>
              </span>
            </template>
            <template #cell(ticketKey)="data">
              <span data-cy="ticket-row-key">{{ data.item.key }}</span>
            </template>
            <template #cell(type)="data">
              <img
                data-cy="ticket-row-type"
                height="20px"
                class="mr-1 mb-1"
                :src="`/img/ticket/${data.item.type.split('TICKET_TYPE_')[1].toLowerCase()}.svg`"
                alt="type">
            </template>
            <template #cell(title)="data">
              <span data-cy="ticket-row-title">{{ data.item.title }}</span>
            </template>
            <template #cell(ticketConnections)="data">
              <div data-cy="ticket-row-connections">
                <template v-for="ref in data.item.references">
                  <p
                    v-if="ref.id"
                    :key="ref.id"
                    class="mb-0">
                    <span v-if="findConnectionId(ref, 'prop') && computedAllConnections.properties">
                      <template v-if="getConnection(findConnectionId(ref, 'prop'))">
                        <router-link
                          v-if="!isMarketingModule"
                          class="external-link"
                          :to="redirectToDetailPage(getConnection(findConnectionId(ref, 'prop')), 'prop')">
                          {{ getConnection(findConnectionId(ref, 'prop')).name || '-' }}
                        </router-link>
                        <span v-else>
                          {{ getConnection(findConnectionId(ref, 'prop')).name || '-' }}
                        </span>
                      </template>
                      <template v-else>
                        -
                      </template>
                      >
                    </span>
                    <span v-if="findConnectionId(ref, 'building') && computedAllConnections.buildings">
                      <template v-if="getConnection(findConnectionId(ref, 'building'))">
                        <router-link
                          v-if="!isMarketingModule"
                          class="external-link"
                          :to="redirectToDetailPage(getConnection(findConnectionId(ref, 'building')), 'building')">
                          {{ getConnection(findConnectionId(ref, 'building')).name || '-' }}
                        </router-link>
                        <span v-else>
                          {{ getConnection(findConnectionId(ref, 'building')).name || '-' }}
                        </span>
                      </template>
                      <template v-else>
                        -
                      </template>
                      >
                    </span>
                    <span v-if="findObjectConnectionId(ref) && computedAllConnections.objects">
                      <template v-if="getConnection(findObjectConnectionId(ref))">
                        <router-link
                          v-if="!isMarketingModule"
                          class="external-link"
                          :to="redirectToDetailPage(getConnection(findObjectConnectionId(ref)), 'obj')">
                          {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) || '-' }}
                        </router-link>
                        <span v-else>
                          {{ getObjectConnectionLabel(getConnection(findObjectConnectionId(ref))) || '-' }}
                        </span>
                      </template>
                      <template v-else>
                        -
                      </template>
                      >
                    </span>
                    <span v-if="getDeviceRoom(ref)">
                      <a
                        v-if="!isMarketingModule"
                        class="external-link cursor-pointer"
                        href="#"
                        @click.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id)"
                        @mousedown.middle.prevent="navigateToRoom(getDeviceRoom(ref), getDeviceRoom(ref).id, true)">
                        {{ getDeviceRoom(ref).name }}
                      </a>
                      <template v-else>{{ getDeviceRoom(ref).name }}</template>
                      >
                    </span>
                    <span
                      v-if="ref.id.startsWith('ins') && computedAllConnections.insurances"
                      class="external-link">
                      <a
                        v-if="!isMarketingModule"
                        class="external-link link"
                        @click="setInsuranceId(getConnection(ref.id), false)"
                        @click.middle="setInsuranceId(getConnection(ref.id), true)">
                        <template v-if="getConnection(ref.id)">
                          {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id).type) }}
                          <template v-if="getReferenceName(ref.id) !== ''">
                            {{ ' - ' + getReferenceName(ref.id) }}
                          </template>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </a>
                      <span v-else>
                        <template v-if="getConnection(ref.id)">
                          {{ $t('message.onBoarding.buildings.insurances.type.' + getConnection(ref.id)?.type) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </span>
                    </span>
                    <span
                      v-if="ref.id.startsWith('mortgage') && computedAllConnections.mortgages"
                      class="external-link">
                      <a
                        v-if="!isMarketingModule"
                        class="external-link link"
                        @click="setMortgageId(getConnection(ref.id), false)"
                        @click.middle="setMortgageId(getConnection(ref.id), true)">
                        <template v-if="getConnection(ref.id)">
                          {{ getConnection(ref.id).bankName + ' - ' +
                            $t('message.onBoarding.mortgage.mortgageDesignation.' +
                              getConnection(ref.id).mortgageDesignation) }}
                          <template v-if="getReferenceName(ref.id) !== ''">
                            {{ ' - ' + getReferenceName(ref.id) }}
                          </template>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </a>
                      <span v-else>
                        <template v-if="getConnection(ref.id)">
                          {{ getConnection(ref.id).bankName + ' - ' +
                            $t('message.onBoarding.mortgage.mortgageDesignation.' +
                              getConnection(ref.id).mortgageDesignation) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </span>
                    </span>
                    <span v-if="ref.id.startsWith('device') && computedAllConnections.devices">
                      <router-link
                        v-if="!isMarketingModule"
                        class="external-link"
                        :to="getConnection(ref.id) !== undefined ? redirectToDeviceDetail(getConnection(ref.id)) : ''">
                        <template
                          v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                          {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </router-link>
                      <span v-else>
                        <template
                          v-if="getConnection(ref.id)?.type && getConnection(ref.id)?.type !== 'DEVICE_TYPE_UNDEFINED'">
                          {{ getDeviceTypeLabel(getConnection(ref.id).type) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </span>
                    </span>
                    <span v-if="ref.id.startsWith('obj') && computedAllConnections.objects">
                      <router-link
                        v-if="!isMarketingModule"
                        class="external-link"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'obj') : ''">
                        {{ getObjectConnectionLabel(getConnection(ref.id)) || '' }}
                      </router-link>
                      <span v-else>
                        {{ getObjectConnectionLabel(getConnection(ref.id)) }}
                      </span>
                    </span>
                    <span v-else-if="ref.id.startsWith('building') && computedAllConnections.buildings">
                      <router-link
                        v-if="!isMarketingModule"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'building') : ''">
                        {{ getConnection(ref.id)?.name || '' }}
                      </router-link>
                      <span v-else>
                        {{ getConnection(ref.id)?.name || '' }}
                      </span>
                    </span>
                    <span v-else-if="ref.id.startsWith('prop') && computedAllConnections.properties">
                      <router-link
                        v-if="!isMarketingModule"
                        class="external-link"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'prop') : ''">
                        {{ getConnection(ref.id)?.name || '' }}
                      </router-link>
                      <span v-else>
                        {{ getConnection(ref.id)?.name || '' }}
                      </span>
                    </span>
                    <span v-else-if="ref.id.startsWith('contact') && computedAllConnections.contacts">
                      <router-link
                        v-if="!isMarketingModule"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetailPage(getConnection(ref.id), 'contact') : ''">
                        {{ getConnection(ref.id)?.name || '' }}
                      </router-link>
                      <span v-else>
                        {{ getConnection(ref.id)?.name || '' }}
                      </span>
                    </span>
                    <span v-if="ref.id.startsWith('request')">
                      <router-link
                        v-if="getConnection(ref.id)?.requesters?.length > 0"
                        class="external-link"
                        :to="redirectToRequestDetail(ref.objectId, ref.id)">
                        {{ getContactName(getConnection(ref.id)?.requesters?.[0]?.contactId) }}
                      </router-link>
                    </span>
                    <span v-else-if="ref.id.startsWith('tenancy')">
                      <router-link
                        v-if="!isMarketingModule"
                        class="external-link"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'tenants') : ''">
                        <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                          {{ getContactName(contact) }}
                        </template>
                      </router-link>
                      <span v-else>
                        <template v-for="contact in (getConnection(ref.id)?.tenant?.contactIds || [])">
                          {{ getContactName(contact) }}
                        </template>
                      </span>
                    </span>
                    <span v-else-if="ref.id.startsWith('condo')">
                      <router-link
                        v-if="!isMarketingModule"
                        class="external-link"
                        :to="getConnection(ref.id) !== undefined ? redirectToDetail(getConnection(ref.id), ref.id, 'condominium') : ''">
                        <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                          {{ getContactName(contact) }}
                        </template>
                      </router-link>
                      <span v-else>
                        <template v-for="contact in (getConnection(ref.id)?.owner?.contactIds || [])">
                          {{ getContactName(contact) }}
                        </template>
                      </span>
                    </span>
                    <span v-else-if="ref.id.startsWith('room')">
                      <a
                        v-if="!isMarketingModule"
                        class="external-link cursor-pointer"
                        href="#"
                        @click.prevent="navigateToRoom(getConnection(ref.id), ref.id)"
                        @mousedown.middle.prevent="navigateToRoom(getConnection(ref.id), ref.id, true)">
                        {{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}
                      </a>
                      <span v-else>
                        {{ getConnection(ref.id) !== null ? getConnection(ref.id).name : '-' }}
                      </span>
                    </span>
                  </p>
                  <p
                    v-else
                    :key="'else-list-' + ref.id">
                    -
                  </p>
                </template>
              </div>
            </template>
            <template #cell(assignee)="data">
              <span data-cy="ticket-row-assignee">
                <template v-if="data.item.assignee !== null">
                  <template v-if="data.item.assignee.userId === 'ailean'">
                    ailean
                  </template>
                  <template v-else>
                    {{ data.item.assignee.name }} - <b>{{ data.item.assignee.accountName }}</b>
                  </template>
                </template>
              </span>
            </template>
            <template #cell(ticketPriority)="data">
              <img
                data-cy="ticket-row-priority"
                :src="`/img/priority/prio-${data.item.priority}.svg`"
                :alt="String($t('message.ticketOverview.priority.title'))"
                height="15px">
            </template>
            <template #cell(ticketInvoice)="data">
              <a
                v-if="data.item.invoiceDocumentId !== '' && listDocumentInvoices.length > 0"
                class="external-link"
                :href="getInvoiceURL(data.item.invoiceDocumentId)"
                target="_blank">
                {{ getDocumentName(data.item.invoiceDocumentId) }}
              </a>
              <span v-else>
                -
              </span>
            </template>
            <template #cell(ticketExecuteFrom)="data">
              <span data-cy="ticket-row-execute-from">{{ data.item.startDate | objectToDate }}</span>
            </template>
            <template #cell(ticketExecuteUntil)="data">
              <span data-cy="ticket-row-execute-until">{{ data.item.dueDate | objectToDate }}</span>
            </template>
            <template #cell(receivedOpened)="data">
              <div
                v-if="getTicketMailEntry(data.item.id) && data.item.createdAt >= 1709638200"
                data-cy="ticket-row-received-opened"
                class="text-center">
                <template v-if="getTicketMailEntry(data.item.id)?.mailType === 'MAIL_TYPE_IMIP'">
                  -
                </template>
                <template v-else>
                  <template
                    v-if="getTicketMailEntry(data.item.id)?.deliverData && getTicketMailEntry(data.item.id)?.deliverData?.status === 'DELIVER_STATUS_DELIVERED'">
                    <coozzy-success-icon />
                  </template>
                  <template
                    v-else-if="getTicketMailEntry(data.item.id)?.deliverData && getTicketMailEntry(data.item.id)?.deliverData?.status === 'DELIVER_STATUS_PENDING'">
                    <coozzy-pending-icon />
                  </template>
                  <template v-else>
                    <coozzy-fail-icon
                      v-b-tooltip.hover.left
                      :title="getTicketMailEntry(data.item.id)?.deliverData?.errorMessage || ''" />
                  </template>
                  /
                  <template
                    v-if="getTicketMailEntry(data.item.id)?.engagementData && getTicketMailEntry(data.item.id)?.engagementData?.status === 'ENGAGEMENT_STATUS_OPENED'">
                    <coozzy-success-icon />
                  </template>
                  <template v-else>
                    <coozzy-fail-icon />
                  </template>
                </template>
              </div>
              <div
                v-else
                data-cy="ticket-row-received-opened"
                class="text-center">
                -
              </div>
            </template>
            <template #cell(operator)="data">
              <span data-cy="ticket-row-operator">
                <template v-if="data.item.correspondences.length > 0">
                  {{ data.item.correspondences[0].name }}
                </template>
                <template v-else>
                  -
                </template>
              </span>
            </template>
            <template #cell(progress)="data">
              <span data-cy="ticket-row-progress">
                <template v-if="data.item.type === 'TICKET_TYPE_CHECKLIST' && data.item.checklist.length > 0">
                  {{ getTasksDone(data.item) + '/' + data.item.checklist.length }}
                </template>
                <template v-else>
                  -
                </template>
              </span>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            data-cy="ticket-pagination"
            align="center"
            class="mb-3"
            :total-rows="totalTickets"
            :per-page="nbrPerPage" />
        </div>
      </div>
    </div>

    <b-modal
      :id="'confirmationModalLinkTicket'"
      ref="confirmationModalLinkTicket"
      data-cy="ticket-link-mail-modal"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.marketingMessages.linkMailToTicket.title')">
      <div class="col">
        <p>{{ $t('message.marketingMessages.linkMailToTicket.text') }}</p>
      </div>
      <div class="col pl-0">
        <coozzy-button
          data-cy="ticket-link-mail-cancel-btn"
          size="small"
          class="mb-0 border"
          design="transparent"
          @click="$bvModal.hide('confirmationModalLinkTicket')">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-link-mail-confirm-btn"
          size="small"
          class="float-right mb-0"
          design="green"
          :disabled="disabledLinkBtn"
          @click="linkTickets()">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </b-modal>
    <b-modal
      :id="'changeAssigneeModal'"
      ref="changeAssigneeModal"
      data-cy="ticket-change-assignee-modal"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.ticketOverview.changeAssignee')">
      <div class="col p-0 mb-3">
        <coozzy-multiselect
          v-model="newAssignee"
          data-cy="ticket-select-new-assignee"
          :options="employeeList.filter(x=> x.blocked === false)"
          :multiple="false"
          :placeholder="String($t('message.employeesSettings.employees'))"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :custom-label="labelEmployee"
          track-by="id" />
      </div>
      <div class="col p-0">
        <coozzy-button
          data-cy="ticket-change-assignee-cancel-btn"
          size="small"
          class="mb-0 border"
          design="transparent"
          @click="hideChangeAssigneeModal()">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-change-assignee-confirm-btn"
          size="small"
          class="float-right mb-0"
          design="green"
          @click="editTicketsAssignee()">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </b-modal>
    <b-modal
      :id="'changeWatchersModal'"
      ref="changeWatchersModal"
      data-cy="ticket-change-watchers-modal"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.ticketOverview.startWatching')">
      <div class="col p-0 mb-3">
        <coozzy-multiselect
          v-model="listNewWatchers"
          data-cy="ticket-select-new-watchers"
          :options="employeeList.filter(x=> x.blocked === false)"
          :multiple="true"
          :placeholder="String($t('message.employeesSettings.employees'))"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :taggable="false"
          :custom-label="labelEmployee"
          track-by="id" />
      </div>
      <div class="col p-0">
        <coozzy-button
          data-cy="ticket-change-watchers-cancel-btn"
          size="small"
          class="mb-0 border"
          design="transparent"
          @click="hideChangeWatchersModal()">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-change-watchers-confirm-btn"
          size="small"
          class="float-right mb-0"
          design="green"
          @click="editTicketsWatchers()">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </b-modal>
    <assemble-list-modal
      ref="assembleListModal"
      data-cy="ticket-assemble-list-modal"
      modal-id="assembleListModal"
      :fields="selectedFields"
      :default-fields="dataFields"
      @save-fields="saveFields" />
    <b-modal
      v-if="showDeleteTicketModal"
      id="deleteConfirmationModal"
      ref="deleteConfirmationModal"
      data-cy="ticket-delete-confirmation-modal"
      :title="$t('message.ticketOverview.deleteTicketModal.title')"
      hide-footer
      no-close-on-backdrop>
      <p>{{ $t('message.ticketOverview.deleteTicketModal.text') }}</p>
      <div class="col">
        <coozzy-button
          data-cy="ticket-delete-cancel-btn"
          class="border mb-0"
          design="transparent"
          size="small"
          @click="hideDeleteConfirmationModal">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-delete-confirm-btn"
          class="float-right mb-0"
          design="green"
          size="small"
          @click="confirmDeletion">
          {{ $t('message.onBoardingTabs.confirmModal.confirmationButton') }}
        </coozzy-button>
      </div>
    </b-modal>
    <b-modal
      v-if="showChangeStatus"
      id="changeStatusModal"
      ref="changeStatusModal"
      data-cy="ticket-change-status-modal"
      :title="$t('message.ticketOverview.changeStatusModal.title')"
      hide-footer
      no-close-on-backdrop>
      <p
        class="mb-2">
        {{ $t('message.ticketOverview.changeStatusModal.text') }}
      </p>
      <coozzy-form-select
        id="newStatus"
        v-model="newStatus"
        data-cy="ticket-select-new-status"
        class="mb-2">
        <option
          v-for="(status, index) in availableStatusOptions"
          :key="status + '_' + index"
          :value="status">
          {{ $t('message.ticketOverview.status.' + status) }}
        </option>
      </coozzy-form-select>
      <div class="col p-0">
        <coozzy-button
          data-cy="ticket-change-status-cancel-btn"
          class="border mb-0"
          design="transparent"
          size="small"
          @click="hideChangeChangeStatus">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-change-status-confirm-btn"
          class="float-right mb-0"
          design="green"
          size="small"
          @click="updateTicketsStatus">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </b-modal>
    <b-modal
      v-if="showInformOperatorModal"
      id="informOperatorModalOverview"
      ref="informOperatorModalOverview"
      data-cy="ticket-inform-operator-modal"
      :title="$t('message.ticketOverview.informOperatorModal.title')"
      hide-footer
      no-close-on-backdrop
      @hide="onInformOperatorModalHide">
      <p>{{ $t('message.ticketOverview.informOperatorModal.descriptionPlural') }}</p>
      <div class="col">
        <coozzy-button
          data-cy="ticket-inform-operator-skip-btn"
          class="border mb-0"
          design="transparent"
          size="small"
          @click="proceedBulkAction(true)">
          {{ $t('message.ticketOverview.informOperatorModal.doNotInform') }}
        </coozzy-button>
        <coozzy-button
          data-cy="ticket-inform-operator-confirm-btn"
          class="float-right mb-0"
          design="green"
          size="small"
          @click="proceedBulkAction(false)">
          {{ $t('message.ticketOverview.informOperatorModal.inform') }}
        </coozzy-button>
      </div>
    </b-modal>
    <coozzy-confirmation-modal
      ref="informOperatorDiscardModal"
      modal-id="informOperatorDiscardModal"
      modal-ref="informOperatorDiscardModalInner"
      hide-save
      @discard="discardInformOperatorChanges"
      @cancel="cancelInformOperatorClose" />
    <report-damage-insurance-modal
      :visible.sync="showReportDamageInsurance"
      :ticket-entries="selectedEntries"
      @hide="showReportDamageInsurance = false" />
  </section>
</template>

<script lang="ts">
import TicketCard from './TicketCard.vue'
import TicketApi from '@/misc/apis/TicketApi'
import { executeBulkInChunks, executeIndividualInChunks } from '@/misc/utils/bulkOperations'
import { mapActions, mapGetters } from 'vuex'
import { routeChecks } from '@/mixins/routeChecks'
import CoozzyMultiselect from '@/framework/components/multiselect/CoozzyMultiselect.vue'
import CoozzyMultiselectHtmlOption from '@/framework/components/multiselect/CoozzyMultiselectHtmlOption.vue'
import Vue, { PropType } from 'vue'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import { user } from '@/mixins/user'
import ObjectApi from '@/misc/apis/ObjectApi'
import ContactApi from '@/misc/apis/ContactApi'
import MessageApi from '@/misc/apis/MessageApi'
import RequestApi from '@/marketingBasic/api/RequestApi'
import { formatting } from '@/mixins/formatting'
import RoomApi from '@/misc/apis/RoomApi'
import UserApi from '@/misc/apis/UserApi'
import AileanApi from '@/misc/apis/AileanApi'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import ShareApi from '@/misc/apis/ShareApi'
import ContactSearchSelect from '@/framework/components/search/ContactSearchSelect.vue'
import CoozzyAssigneeMultiselect from '@/framework/components/multiselect/CoozzyAssigneeMultiselect.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import { tables } from '@/mixins/tables'
import CoozzyDropdown from '@/framework/components/dropdown/CoozzyDropdown.vue'
import { mail } from '@/mixins/mail'
import CoozzyDropdownItem from '@/framework/components/dropdown/CoozzyDropdownItem.vue'
import CoozzySuccessIcon from '@/framework/components/icons/CoozzySuccessIcon.vue'
import { ticket } from '@/mixins/ticket'
import { ticketConnections } from '@/mixins/ticketConnections'
import CoozzyFailIcon from '@/framework/components/icons/CoozzyFailIcon.vue'
import CoozzyPendingIcon from '@/framework/components/icons/CoozzyPendingIcon.vue'
import debounce from 'debounce'
import CoozzyFiltersIcon from '@/framework/components/icons/CoozzyFiltersIcon.vue'
import SearchApi from '@/misc/apis/SearchApi'
import AssembleListModal from '@/contact/components/AssembleListModal.vue'
import MediaApi from '@/misc/apis/MediaApi'
import ReportDamageInsuranceModal from '@/components/modals/ReportDamageInsuranceModal.vue'
import CoozzyConfirmationModal from '@/framework/components/modal/CoozzyConfirmationModal.vue'
import { MediadocumentDocument, StoreMedia, TicketTicket, TicketTicketType, V2Account, V2User } from '@/types/api'
import { Contact, EmployeeFilterOption, EmployeeLabelOption, EmployeeOption, GenericOption, TicketConnectionsState, TicketMailEntry } from '@/types/models'
import { aic } from '@/mixins/aic'
import ReportDamageDropdownItem from '@/components/aic/ReportDamageDropdownItem.vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default Vue.extend({
  name: 'TicketOverviewData',
  components: {
    AssembleListModal,
    CoozzyFiltersIcon,
    CoozzyPendingIcon,
    CoozzyFailIcon,
    CoozzySuccessIcon,
    CoozzyDropdownItem,
    CoozzyDropdown,
    CoozzyButton,
    CoozzyFormSelect,
    CoozzySpinner,
    CoozzyFormCheckbox,
    CoozzyFormInput,
    CoozzyAssigneeMultiselect,
    CoozzyMultiselect,
    CoozzyMultiselectHtmlOption,
    TicketCard,
    ContactSearchSelect,
    ReportDamageInsuranceModal,
    CoozzyConfirmationModal,
    ReportDamageDropdownItem,
    DynamicScroller,
    DynamicScrollerItem
  },
  mixins: [routeChecks, tables, user, formatting, mail, ticket, ticketConnections, aic],
  props: {
    fromHistory: {
      type: Boolean,
      default: false
    },
    property: {
      type: Object as PropType<GenericOption | null>,
      default: null
    },
    mainReferences: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    allReferences: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    defaultEmptyAssignee: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: false
    },
    defaultText: {
      type: String,
      default: ''
    },
    defaultType: {
      type: String,
      default: ''
    },
    defaultStatus: {
      type: String,
      default: ''
    },
    defaultCreator: {
      type: String,
      default: ''
    },
    defaultAssigne: {
      type: String,
      default: ''
    },
    defaultPriority: {
      type: String,
      default: ''
    },
    defaultOverdue: {
      type: String,
      default: ''
    },
    defaultWatched: {
      type: String,
      default: ''
    },
    defaultNewEvent: {
      type: String,
      default: ''
    },
    defaultUploadedInvoice: {
      type: String,
      default: ''
    },
    closedTicket: {
      type: Boolean,
      default: false
    },
    defaultDevice: {
      type: Array as PropType<GenericOption[]>,
      default: (): GenericOption[] => []
    },
    deviceList: {
      type: Array as PropType<GenericOption[]>,
      default: (): GenericOption[] => []
    },
    linkEmail: {
      type: String as PropType<string | null>,
      default: null
    },
    nameLinked: {
      type: String as PropType<string | null>,
      default: null
    },
    defaultOperator: {
      type: String,
      default: ''
    },
    ownerIds: {
      type: String,
      default: ''
    },
    includeClosed: {
      type: Boolean,
      default: false
    },
    referenceIds: {
      type: String,
      default: ''
    },
    draftTicket: {
      type: Boolean,
      default: false
    },
    prevRoute: {
      type: Object as PropType<Record<string, unknown> | null>,
      default: null
    }
  },
  data() {
    return {
      abortController: null as AbortController | null,
      isDataLoaded: {
        object: false,
        building: false,
        property: false,
        filters: false,
        operator: false,
        assignee: false,
        employee: false
      },
      initialLoadTriggered: false,
      hasLoadedInitialTickets: false,
      readyForLoad: false,
      mailList: [] as TicketMailEntry[],
      debounceSearchInput: null as ReturnType<typeof setTimeout> | null,
      debounceFilterChange: null as ReturnType<typeof setTimeout> | null,
      debounceReadyForLoad: null as ReturnType<typeof setTimeout> | null,
      loadConnectionsGeneration: 0,
      disabledLinkBtn: false,
      isFirstLoad: false,
      emptyAssignee: this.defaultEmptyAssignee === 'true' || this.defaultEmptyAssignee,
      searchStatus: [] as string[],
      searchPriority: [] as string[],
      searchAssignee: [] as EmployeeFilterOption[],
      searchCreator: [] as EmployeeFilterOption[],
      searchType: [] as string[],
      searchDevice: [] as GenericOption[],
      allConnections: {
        properties: [],
        buildings: [],
        objects: [],
        condominiums: [],
        tenancies: [],
        devices: [],
        contacts: [],
        requests: [],
        rooms: [],
        mortgages: [],
        insurances: []
      } as TicketConnectionsState,
      listContacts: [] as Contact[],
      searchWatcher: this.defaultWatched === 'true',
      searchDueDate: this.defaultOverdue === 'true',
      searchNewEvent: this.defaultNewEvent === 'true',
      searchUploadedInvoice: this.defaultUploadedInvoice === 'true',
      searchText: this.defaultText,
      showEntireProperty: true,
      loading: true,
      dragging: false,
      draggingCollumn: null as string | null,
      draggingTicket: null as TicketTicket | null,
      draggingOver: null as string | null,
      ticketList: [] as TicketTicket[],
      ticketUnsortedList: [] as TicketTicket[],
      openTickets: [] as TicketTicket[],
      progressTickets: [] as TicketTicket[],
      doneTickets: [] as TicketTicket[],
      selectedTicket: null as TicketTicket | null,
      isColumnView: !this.closedTicket && !this.draftTicket,
      scrollBuffer: 600,
      fields: [
        {
          key: 'newEvent',
          label: '',
          thClass: 'th-newEvent',
          tdClass: 'align-middle border-right-0 newEvent-cell',
          visible: true
        },
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell',
          visible: true
        }
      ],
      dataFields: [
        {
          key: 'type',
          label: this.$t('message.tableColumnHeadings.type'),
          tdClass: 'align-middle d-md-table-cell',
          thClass: 'd-md-table-cell',
          selected: true,
          visible: true
        },
        {
          key: 'ticketKey',
          label: this.$t('message.tableColumnHeadings.ticketKey'),
          tdClass: 'align-middle',
          selected: true,
          visible: true
        },
        {
          key: 'title',
          label: this.$t('message.tableColumnHeadings.title'),
          tdClass: 'align-middle',
          selected: true,
          visible: true
        },
        {
          key: 'ticketConnections',
          label: this.$t('message.tableColumnHeadings.ticketConnections'),
          tdClass: 'align-middle d-md-table-cell',
          thClass: 'd-md-table-cell',
          selected: true,
          visible: true
        },
        {
          key: 'ticketInvoice',
          label: this.$t('message.tableColumnHeadings.ticketInvoice'),
          tdClass: 'align-middle text-center d-sm-table-cell',
          thClass: 'd-sm-table-cell text-center',
          selected: true,
          visible: true
        },
        {
          key: 'assignee',
          label: this.$t('message.tableColumnHeadings.assignee'),
          tdClass: 'align-middle d-lg-table-cell',
          thClass: 'd-lg-table-cell',
          selected: true,
          visible: true
        },
        {
          key: 'ticketExecuteFrom',
          label: this.$t('message.tableColumnHeadings.ticketExecuteFrom'),
          tdClass: 'align-middle d-md-table-cell',
          thClass: 'd-md-table-cell',
          selected: true,
          visible: true
        },
        {
          key: 'ticketExecuteUntil',
          label: this.$t('message.tableColumnHeadings.ticketExecuteUntil'),
          tdClass: 'align-middle d-md-table-cell',
          thClass: 'd-md-table-cell',
          selected: true,
          visible: true
        },
        {
          key: 'receivedOpened',
          label: this.$t('message.tableColumnHeadings.receivedOpened'),
          tdClass: 'align-middle text-center d-sm-table-cell',
          thClass: 'd-sm-table-cell text-center',
          selected: true,
          visible: true
        },
        {
          key: 'status',
          label: this.$t('message.tableColumnHeadings.status'),
          tdClass: 'align-middle',
          selected: true,
          visible: !this.closedTicket
        },
        {
          key: 'operator',
          label: this.$t('message.tableColumnHeadings.operator'),
          tdClass: 'align-middle text-center d-sm-table-cell',
          thClass: 'd-sm-table-cell text-center',
          selected: false,
          visible: true
        },
        {
          key: 'progress',
          label: this.$t('message.tableColumnHeadings.progress'),
          tdClass: 'align-middle text-center d-sm-table-cell',
          thClass: 'd-sm-table-cell text-center',
          selected: true,
          visible: true
        },
        {
          key: 'ticketPriority',
          label: this.$t('message.tableColumnHeadings.ticketPriority'),
          tdClass: 'align-middle text-center d-sm-table-cell',
          thClass: 'd-sm-table-cell text-center',
          selected: true,
          visible: true
        }
      ],
      selectedFields: [] as Array<{ key: string; selected?: boolean; visible?: boolean }>,
      searchProperty: [] as GenericOption[],
      searchBuilding: [] as GenericOption[],
      searchObject: [] as GenericOption[],
      searchOwner: [] as GenericOption[],
      involvedPeople: [] as Array<{ objectID: string }>,
      currentPage: 1,
      nbrPerPage: 5,
      currentEmployeeList: [] as V2User[],
      listAllEmployees: [] as EmployeeOption[],
      aileanEnabled: false,
      availableStatusOptions: ['TICKET_STATUS_OPEN', 'TICKET_STATUS_IN_PROGRESS', 'TICKET_STATUS_DONE', 'TICKET_STATUS_CLOSED'],
      availablePriorityOptions: ['LOW', 'DEFAULT', 'HIGH'],
      ownerAccounts: [] as V2Account[],
      totalTickets: 0,
      referencesOwners: [] as V2Account[],
      selectedEntries: [] as TicketTicket[],
      showChangeAssignee: false,
      showChangeWatchers: false,
      showChangeStatus: false,
      showInformOperatorModal: false,
      showReportDamageInsurance: false,
      pendingBulkAction: '' as 'status' | 'assignee' | '',
      reportDamageInsuranceLoading: false,
      newAssignee: null as V2User | null,
      listNewWatchers: [] as V2User[],
      newStatus: 'TICKET_STATUS_OPEN',
      selectAllVisibleEntries: false,
      selectAllEntries: false,
      allEntries: [] as TicketTicket[],
      isFromProperty: true,
      showDeleteTicketModal: false,
      availablePropertyOptions: [] as GenericOption[],
      availableBuildingOptions: [] as GenericOption[],
      availableObjectOptions: [] as GenericOption[],
      preservedCreatorFilterIds: [] as string[],
      listDocumentInvoices: [] as MediadocumentDocument[],
      listMediaInvoices: [] as StoreMedia[]
    }
  },
  computed: {
    availableTypeOptions() {
      return [TicketTicketType.TICKET_TYPE_TASK, TicketTicketType.TICKET_TYPE_ORDER, TicketTicketType.TICKET_TYPE_CHECKLIST, ...(this.aicEnabled ? [TicketTicketType.TICKET_TYPE_CLAIM] : [])]
    },
    onlyOrdersSelected() {
      return this.selectedEntries.length > 1 && this.selectedEntries.every(item => item.type === 'TICKET_TYPE_ORDER')
    },
    filtredAvailableStatusOptions() {
      // all status options except 'TICKET_STATUS_CLOSED'
      return this.availableStatusOptions.filter(x => x !== 'TICKET_STATUS_CLOSED')
    },
    readyForLoadValue() {
      return this.readyForLoad
    },
    selectedEntriesText(): string {
      const count = this.selectAllEntries && this.selectAllVisibleEntries ? this.totalTickets : this.selectedEntries.length
      return String(this.$t('message.generic.selectedEntries')) + ':  ' + count
    },
    contactSearchFiltersOperator() {
      return { isOwner: false, active: true, isEmployee: false, isOnlyInterestedParty: false }
    },
    computedAllConnections(): TicketConnectionsState {
      return this.allConnections as TicketConnectionsState
    },
    isFiltered() {
      return this.searchText !== '' ||
      this.searchWatcher === true ||
      this.searchDueDate === true ||
      this.searchNewEvent === true ||
      this.searchUploadedInvoice === true ||
      this.searchPriority.length > 0 ||
      this.searchAssignee.length > 0 ||
      this.emptyAssignee === true ||
      this.searchCreator.length > 0 ||
      this.searchType.length > 0 ||
      this.searchStatus.length > 0 ||
      this.searchDevice.length > 0 ||
      this.searchProperty.length > 0 ||
      this.searchBuilding.length > 0 ||
      this.searchObject.length > 0 ||
      this.searchOwner.length > 0 ||
      this.involvedPeople.length > 0
    },
    employeeFilteredListWithSystem (): EmployeeFilterOption[] {
      const system = {
        label: 'system',
        value: 'system',
        active: true,
        company: '',
        profile: null,
        accountId: this.accountId
      }
      return [system, ...this.employeeFilteredList]
    },
    employeeFilteredList(): EmployeeFilterOption[] {
      if (this.listAllEmployees.length > 0) {
        const list: EmployeeFilterOption[] = []
        this.listAllEmployees.forEach(element => {
          const isSupportUser = element.value?.email ? element.value.email.startsWith('support.') && element.value.email.endsWith('@my-prop.ch') : false
          if (!isSupportUser) {
            list.push({
              label: element.label,
              value: element.value.id,
              active: !element.value.blocked,
              company: element.company,
              profile: element.value.profile,
              accountId: element.value.accountId
            })
          }
        })
        const customSort = (a: EmployeeFilterOption, b: EmployeeFilterOption) => {
          // Sort by 'active' status first (true comes before false)
          if (a.active !== b.active) {
            return a.active ? -1 : 1
          }
          // sort first by accountId
          if (parseInt(a.accountId) === parseInt(this.$store.getters['user/getAccountId'])) {
            return -1
          }
          if (parseInt(b.accountId) === parseInt(this.$store.getters['user/getAccountId'])) {
            return 1
          }
        }
        const sortedList = list.sort((a, b) => {
          // sort by lastname and then with firstname
          if (a.profile.lastName.toLowerCase() < b.profile.lastName.toLowerCase()) { return 1 }
          if (a.profile.lastName.toLowerCase() > b.profile.lastName.toLowerCase()) { return -1 }
          if (a.profile.firstName.toLowerCase() < b.profile.firstName.toLowerCase()) { return 1 }
          if (a.profile.firstName.toLowerCase() > b.profile.firstName.toLowerCase()) { return -1 }
          // If both are active or both are inactive, sort by 'company'
          return a.company.localeCompare(b.company)
        }).sort(customSort)

        if (this.aileanEnabled) {
          sortedList.unshift({
            label: 'ailean',
            value: 'ailean',
            active: true,
            company: '',
            profile: null,
            accountId: ''
          } as EmployeeFilterOption)
        }

        return sortedList
      }
      return []
    },
    openScrollerBuffer() {
      return this.sortedOpenTicket.length >= 200 ? this.scrollBuffer : Number.MAX_SAFE_INTEGER
    },
    progressScrollerBuffer() {
      return this.sortedProgressTicket.length >= 200 ? this.scrollBuffer : Number.MAX_SAFE_INTEGER
    },
    doneScrollerBuffer() {
      return this.sortedDoneTicket.length >= 200 ? this.scrollBuffer : Number.MAX_SAFE_INTEGER
    },
    sortedOpenTicket: {
      get(): TicketTicket[] {
        return this.openTickets
      },
      set(value: TicketTicket[]) {
        if (value) {
          this.openTickets = value
        }
      }
    },
    sortedProgressTicket: {
      get(): TicketTicket[] {
        return this.progressTickets
      },
      set(value: TicketTicket[]) {
        if (value) {
          this.progressTickets = value
        }
      }
    },
    sortedDoneTicket: {
      get(): TicketTicket[] {
        return this.doneTickets
      },
      set(value: TicketTicket[]) {
        if (value) {
          this.doneTickets = value
        }
      }
    },
    availableOwnerOptions(): Array<{ value: string; company: string }> {
      if (this.referencesOwners.length > 0) {
        const list: Array<{ value: string; company: string }> = []
        this.referencesOwners.filter(x => x.subType?.toLowerCase() === 'owner').forEach(element => {
          let name = ''
          if (element.company) {
            name = element.company.name
          } else if (element.individual) {
            name = element.individual.firstName.substr(0, 1) + '.' + element.individual.lastName
          }
          list.push({
            value: element.id,
            company: name
          })
        })
        return list.sort((a, b) => (a.company === null ? 0 : a.company > b.company ? 1 : -1))
      }
      return []
    },
    employeeList(): V2User[] {
      if (this.getEmployees().length > 0) {
        return this.getEmployees()
      }
      return []
    },
    filtredPropertyOptions() {
      if (this.availablePropertyOptions.length > 0) {
        const listOwners = this.searchOwner.flatMap(x => x.value) || []
        return this.availablePropertyOptions.filter(x => listOwners.length > 0 ? listOwners.includes(x.ownerId) : x)
      }
      return []
    },
    filtredBuildingOptions() {
      if (this.availableBuildingOptions.length > 0) {
        let list = this.availableBuildingOptions
        if (this.searchOwner.length > 0) {
          const listOwners = this.searchOwner.flatMap(x => x.value) || []
          list = list.filter(x => listOwners.length > 0 ? listOwners.includes(x.ownerId) : x)
        }
        if (this.searchProperty.length > 0) {
          const buildingIds = this.searchProperty.flatMap(x => x.buildingIds || [])
          list = list.filter(x => buildingIds.includes(x.id))
        }
        if (this.fromHistory) {
          if (this.mainReferences[0].startsWith('prop')) {
            const propertyBuildingIds = this.property?.buildingIds
            const connectionProperty = this.allConnections.properties.find(x => x.id === this.mainReferences[0])
            const connectionBuildingIds = connectionProperty?.buildingIds
            const buildingIds = propertyBuildingIds != null ? propertyBuildingIds : (connectionBuildingIds || [])
            if (propertyBuildingIds != null || connectionBuildingIds !== undefined) {
              list = list.filter(x => buildingIds.includes(x.id))
            }
          }
        }
        return list
      }
      return []
    },
    filtredObjectOptions() {
      if (this.availableObjectOptions.length > 0) {
        let list = this.availableObjectOptions
        if (this.searchOwner.length > 0) {
          const listOwners = this.searchOwner.flatMap(x => x.value) || []
          list = list.filter(x => listOwners.length > 0 ? listOwners.includes(x.ownerId) : x)
        }
        if (this.searchBuilding.length > 0) {
          const objectIds = this.searchBuilding.flatMap(x => x.objectIds || [])
          list = list.filter(x => objectIds.includes(x.id))
        }
        if (this.fromHistory) {
          if (this.mainReferences[0].startsWith('prop')) {
            const propertyBuildingIds = this.property?.buildingIds
            const connectionProperty = this.allConnections.properties.find(x => x.id === this.mainReferences[0])
            const connectionBuildingIds = connectionProperty?.buildingIds
            const buildingIds = propertyBuildingIds != null ? propertyBuildingIds : (connectionBuildingIds || [])
            if (propertyBuildingIds != null || connectionBuildingIds !== undefined) {
              const buildings = this.allConnections.buildings.filter(x => buildingIds.some(y => y === x.id))
              const objectIds = buildings.flatMap(x => x.objectIds || [])
              list = list.filter(x => objectIds.includes(x.id))
            }
          }
          if (this.mainReferences[0].startsWith('building')) {
            const building = this.allConnections.buildings.find(x => x.id === this.mainReferences[0])
            const buildingObjectIds = building?.objectIds
            const objectIds = buildingObjectIds || []
            if (buildingObjectIds != null) {
              list = list.filter(x => objectIds.includes(x.id))
            }
          }
        }
        return list
      }
      return []
    },
    combinedValues() {
      return [
        this.showEntireProperty,
        this.isColumnView
      ]
    },
    isAllDataLoaded() {
      // check if every endpoint and loading with algolia is finished, so we can change in the rulr
      return this.isDataLoaded.filters && this.isDataLoaded.operator && this.isDataLoaded.assignee && this.isDataLoaded.object && this.isDataLoaded.building && this.isDataLoaded.property
    },
    selectedEntriesIds() {
      const listEntries = this.selectAllEntries ? this.allEntries : this.selectedEntries
      return listEntries.filter(x => x !== undefined && x !== null).map(obj => obj.id)
    },
    ticketMailMap(): Record<string, TicketMailEntry> {
      const map: Record<string, TicketMailEntry> = {}

      if (this.mailList.length === 0) {
        return map
      }

      // Get all ORDER ticket IDs from current ticket list
      const orderTickets = this.ticketList.filter(t => t.type === 'TICKET_TYPE_ORDER')

      orderTickets.forEach(ticket => {
        const matchingMails = this.mailList
          .filter(mail => mail.referenceId && mail.referenceId.includes(ticket.id))

        if (matchingMails.length > 0) {
          if (matchingMails.length > 1) {
            matchingMails.sort((a, b) => (b.timestamp * 1000) - (a.timestamp * 1000))
          }
          map[ticket.id] = matchingMails[0]
        }
      })

      return map
    }
  },
  watch: {
    isAllDataLoaded: function (newVal, oldVal) {
      if (newVal === true && !this.initialLoadTriggered) {
        this.initialLoadTriggered = true
        this.changeTicketUrl()
      }
    },
    isFiltered: {
      immediate: true,
      handler(newVal) {
        this.$emit('is-filtered', newVal)
      }
    },
    combinedValues: {
      deep: true,
      handler: function () {
        if (!this.hasLoadedInitialTickets) {
          return
        }
        if (this.isAllDataLoaded && this.initialLoadTriggered) {
          this.loadTickets()
        }
      }
    },
      readyForLoadValue: function (newVal) {
        if (newVal === true) {
          this.readyForLoad = false
          if (!this.hasLoadedInitialTickets) {
            this.hasLoadedInitialTickets = true
          }
          this.debounceReadyForLoad()
        }
      },
    searchAssignee: function (newVal, oldVal) {
      if (newVal.length === 0 && oldVal.length > 0) {
        this.emptyAssignee = true
      }
      const newString = newVal.map(e => e.value).join(',')
      if (this.$route.path.includes('tickets/closed')) {
        if (newVal.length > 0) {
          localStorage.setItem('filterClosedAssigneeTicketOverview', newString)
        } else {
          localStorage.removeItem('filterClosedAssigneeTicketOverview')
        }
      } else {
        if (newVal.length > 0) {
          localStorage.setItem('filterAssigneeTicketOverview', newString)
        } else {
          localStorage.removeItem('filterAssigneeTicketOverview')
        }
      }

      this.getCountMyUnreadTickets(true)
    },
    currentPage: function () {
      if (!this.hasLoadedInitialTickets) {
        return
      }
      this.handleCheckboxesInsideTable(false)
      this.loadTickets()
    },
    searchCreator: function (newVal, oldVal) {
      if (newVal.length > 0) {
        this.preservedCreatorFilterIds = newVal
          .map(x => (x?.value ?? '').toString())
          .filter(Boolean)
      } else if (oldVal && oldVal.length > 0) {
        this.preservedCreatorFilterIds = []
      }
    },
    nbrPerPage: function () {
      if (!this.hasLoadedInitialTickets) {
        return
      }
      if (!this.isColumnView) {
        this.handleCheckboxesInsideTable(false)
        this.loadTickets()
      }
    },
    selectAllEntries: async function (newValue) {
      if (newValue) {
        this.handleCheckboxesInsideTable(newValue)
        if (this.totalTickets !== this.allEntries.length) {
          this.loadTickets(true)
        }
      }
    },
    ticketList: function (newVal) {
      newVal.some(ticket => ticket.readStatus && !ticket.readStatus.assignee) ? this.$emit('has-notification', true) : this.$emit('has-notification', false)
    },
    availableOwnerOptions: function (newVal) {
      if (newVal.length > 0) {
        const routeQuery = this.$route.query
        const splitOwnersId = this.ownerIds !== '' ? this.ownerIds.split(',') : routeQuery.ownerIds ? routeQuery.ownerIds : []
        this.searchOwner = this.availableOwnerOptions.filter(x => splitOwnersId.includes(x.value))
      }
    },
    sortedOpenTicket: 'forceScrollerUpdate',
    sortedProgressTicket: 'forceScrollerUpdate',
    sortedDoneTicket: 'forceScrollerUpdate'
  },
  async beforeMount() {
    await this.loadEmployees()
    await this.checkAileanEnabled()
    this.getAllNetworkPartner()

    this.debounceSearchInput = debounce(() => {
      this.changeTicketUrl()
    }, 400)

    this.debounceFilterChange = debounce(() => {
      this.changeTicketUrl()
      this.loadTickets()
    }, 200)

    this.debounceReadyForLoad = debounce(() => {
      this.loadTickets()
    }, 200)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onPageScrollForScrollers)
    if (this._scrollerRafId) cancelAnimationFrame(this._scrollerRafId)
  },
  async mounted() {
      window.addEventListener('scroll', this._onPageScrollForScrollers, { passive: true })
      this.scrollBuffer = Math.round(Math.min(900, Math.max(400, (typeof window !== 'undefined' ? window.innerHeight : 800) * 3)))
      if (!this.$route.name?.includes('PropertyDetailsView')) {
        this.isFromProperty = false
      }
      await this.checkAicEnabled()
      this.$watch(vm => [
      vm.searchWatcher,
      vm.searchNewEvent,
      vm.searchUploadedInvoice,
      vm.searchDueDate,
      vm.searchPriority,
      vm.searchAssignee,
      vm.searchCreator,
      vm.involvedPeople,
      vm.searchType,
      vm.searchStatus,
      vm.searchDevice,
      vm.searchOwner,
      vm.searchProperty,
      vm.searchBuilding,
      vm.searchObject,
      vm.isAllDataLoaded], {
        immediate: true,
        handler: function (newVal, oldVal) {
          if (!this.hasLoadedInitialTickets) {
            return
          }

          if (this.isAllDataLoaded && !this.objectsAreSame(newVal, oldVal)) {
            if (!this.fromHistory && (newVal.isAllDataLoaded || newVal.isAllDataLoaded === oldVal.isAllDataLoaded)) {
              this.changeTicketUrl()
            } else {
              this.currentPage = 1
              if (this.debounceFilterChange) {
                this.debounceFilterChange()
              } else {
                this.changeTicketUrl()
                this.loadTickets()
              }
            }
          }
        }
      })
    // adapt columns table list ticket
    this.fields = this.fields.filter(field => field.visible)
    this.dataFields = this.dataFields.filter(x => x.selected).concat(this.dataFields.filter(x => !x.selected))
    const src = this.fromHistory ? 'list_ticket_history' : 'list_ticket_overview'
    SearchApi.loadSettings(this.accountId).then(response => {
      const settings = response.tableSettings
      let hasOldList = false
      if (settings.length > 0) {
        settings.forEach(setting => {
          if (setting.columns.length > 0 && setting.table === src) {
            hasOldList = true
            this.loadFields(setting)
          }
        })
      }
      if (hasOldList === false) {
        this.fields.push(...this.dataFields.filter(x => x.selected))
        this.selectedFields = JSON.parse(JSON.stringify(this.dataFields))
      }
    }).catch(e => {
      console.log(e)
    })
    if (this.mainReferences.length > 0) {
      this.isColumnView = false
    }
    this.getPropertiesOptions()
    this.getBuildingsOptions()
    this.getObjectsOptions()
    if (this.linkEmail) {
      MessageApi.listMailsByIds([this.linkEmail])
        .then(response => {
          this.email = response.mails[0]
        })
    }
    const routeQuery = this.$route.query
    const historyFilterDefaults = this.getHistoryFilterDefaults(routeQuery)
    const defaultStatusValues = this.toFilterArray(this.defaultStatus, routeQuery.defaultStatus, historyFilterDefaults.defaultStatus)
    this.preservedCreatorFilterIds = this.toFilterArray(this.defaultCreator, routeQuery.defaultCreator, historyFilterDefaults.defaultCreator)
    this.searchType = this.availableTypeOptions.filter(x => this.defaultType.includes(x) || routeQuery.defaultType === x)
    this.searchStatus = this.availableStatusOptions.filter(x => defaultStatusValues.includes(x))
    this.searchDevice = this.deviceList.filter(x => this.defaultDevice.length > 0 ? this.defaultDevice[0].value === x.value : false)
    this.searchPriority = this.availablePriorityOptions.filter(x => this.defaultPriority.includes(x) || routeQuery.defaultPriority === x)
    this.searchDueDate = routeQuery.defaultOverdue === 'true'
    this.searchNewEvent = routeQuery.defaultNewEvent === 'true'
    this.searchUploadedInvoice = routeQuery.defaultUploadedInvoice === 'true'
    this.searchWatcher = routeQuery.defaultWatched === 'true'
    this.searchText = this.defaultText !== '' ? this.defaultText : routeQuery.defaultText ? routeQuery.defaultText : ''
    this.isDataLoaded.filters = true
    if (this.defaultOperator !== '' || routeQuery.defaultOperator) {
      const splitOperatorIds = this.toFilterArray(this.defaultOperator, routeQuery.defaultOperator)
      const operatorIdSet = new Set(splitOperatorIds)
      ContactApi.contactResolve(splitOperatorIds)
        .then(response => {
          this.involvedPeople = ([...response.persons, ...response.companies] as Contact[])
            .filter(contact => operatorIdSet.has(contact.id))
            .map(contact => ({ ...contact, objectID: contact.id }))
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.isDataLoaded.operator = true
        })
    } else {
      this.isDataLoaded.operator = true
    }
    setTimeout(() => {
      this.$refs.searchText?.setFocusInput()
    }, 300)

    if (!this.initialLoadTriggered && this.isAllDataLoaded) {
      this.initialLoadTriggered = true
      this.changeTicketUrl()
    }
  },
  methods: {
    ...mapActions('employee', ['loadEmployees']),
    ...mapGetters('employee', ['getEmployees']),
    async checkAileanEnabled() {
      try {
        const response = await AileanApi.hasAileanEnabled(String(this.accountId))
        this.aileanEnabled = response.enabled
      } catch (error) {
        this.aileanEnabled = false
      }
    },
    assigneeHtmlLabel(props: { option: EmployeeFilterOption }): string {
      const option = props.option
      if (option.value === 'ailean') {
        return 'ailean'
      }
      if (option.label === 'system') {
        return String(this.$t('message.ticketOverview.ticket.createdBySystem'))
      }
      return option.label + (option.company ? (' -' + option.company) : '')
    },
    getConnection(id?: string | null): GenericOption | undefined {
      return (ticketConnections.methods.getConnection as (this: unknown, id?: string | null) => GenericOption | undefined).call(this, id)
    },
    findConnectionId(reference: { relatedIds?: string[] } | null | undefined, type: string): string {
      return (ticketConnections.methods.findConnectionId as (this: unknown, reference: { relatedIds?: string[] } | null | undefined, type: string) => string).call(this, reference, type)
    },
    findObjectConnectionId(reference: { id?: string, relatedIds?: string[] } | null | undefined): string | undefined {
      return (ticketConnections.methods.findObjectConnectionId as (this: unknown, reference: { id?: string, relatedIds?: string[] } | null | undefined) => string | undefined).call(this, reference)
    },
    getDeviceRoomId(reference: { id?: string } | null | undefined): string | undefined {
      return (ticketConnections.methods.getDeviceRoomId as (this: unknown, reference: { id?: string } | null | undefined) => string | undefined).call(this, reference)
    },
    getDeviceRoom(reference: { id?: string } | null | undefined): GenericOption | undefined {
      return (ticketConnections.methods.getDeviceRoom as (this: unknown, reference: { id?: string } | null | undefined) => GenericOption | undefined).call(this, reference)
    },
    getObjectConnectionLabel(object: GenericOption | null | undefined): string {
      return (ticketConnections.methods.getObjectConnectionLabel as (this: unknown, object: GenericOption | null | undefined) => string).call(this, object)
    },
    getContactName(contactId: string): string | undefined {
      return (ticketConnections.methods.getContactName as (this: unknown, contactId: string) => string | undefined).call(this, contactId)
    },
    getDeviceTypeLabel(type: string): string {
      const translated = String(this.$t('message.onBoarding.devices.typeValues.' + type))
      return translated.length > 50 ? translated.slice(0, 50) + '...' : translated
    },
    filterHitsWithObjectId(hits: GenericOption[]): GenericOption[] {
      return (hits || []).filter((x: GenericOption) => x && !!x.objectID)
    },
    getTicketMailEntry(ticketId: string): TicketMailEntry | null {
      return this.ticketMailMap[ticketId] || null
    },
    getTasksDone(ticket: TicketTicket): number {
      return ticket.checklist.filter(task => task.status === 'CHECKLIST_ITEM_STATUS_DONE').length
    },
    deleteTicketClicked() {
      this.showDeleteTicketModal = true
      this.$nextTick(() => {
        this.$refs.deleteConfirmationModal.show()
      })
    },
    mergeOrders() {
      const currentRoute = { name: this.$router.currentRoute.name, params: this.$router.currentRoute.params, query: this.$router.currentRoute.query }
      localStorage.setItem('LS_ROUTE_KEY', JSON.stringify(currentRoute))
      const refs = this.selectedEntries.flatMap(entry => entry.references)
      const ticketIds = this.selectedEntriesIds.join(',')
      let propertyIds = []
      let buildingIds = []
      let objectIds = []
      let tenancyIds = []
      let condoOwnerIds = []
      let deviceIds = []
      let contactIds = []
      let roomIds = []
      refs.forEach((item) => {
        switch (true) {
          case item.id.startsWith('prop_'):
            propertyIds.push(item.id)
            break
          case item.id.startsWith('building_'):
            buildingIds.push(item.id)
            break
          case item.id.startsWith('obj_'):
            objectIds.push(item.id)
            break
          case item.id.startsWith('tenancy_'):
            tenancyIds.push(item.id)
            break
          case item.id.startsWith('condominium_'):
            condoOwnerIds.push(item.id)
            break
          case item.id.startsWith('device_'):
            deviceIds.push(item.id)
            break
          case item.id.startsWith('contact_'):
            contactIds.push(item.id)
            break
          case item.id.startsWith('room_'):
            roomIds.push(item.id)
            break
        }
      })
      const query = {
        ticketIds: ticketIds,
        propertyIds: propertyIds.join(','),
        buildingIds: buildingIds.join(','),
        objectIds: objectIds.join(','),
        tenancyIds: tenancyIds.join(','),
        condoOwnerIds: condoOwnerIds.join(','),
        deviceIds: deviceIds.join(','),
        contactIds: contactIds.join(','),
        roomIds: roomIds.join(','),
        source: 'mergeOrders'
      }
      if (this.isOwnerModule) {
        this.$router.push({ name: 'OwnerCreateOrderView', query: query }, () => {})
      } else if (this.isAdminModule) {
        this.$router.push({ name: 'AdminCreateOrderView', query: query }, () => {})
      } else if (this.isAssetModule) {
        this.$router.push({ name: 'AssetCreateOrderView', query: query }, () => {})
      } else if (this.isAccountingModule) {
        this.$router.push({ name: 'AccountingCreateOrderView', query: query }, () => {})
      }
    },
    hideDeleteConfirmationModal() {
      this.$bvModal.hide('deleteConfirmationModal')
      this.showDeleteTicketModal = false
    },
    confirmDeletion() {
      const idsToDelete = this.selectedEntriesIds.filter(id => id !== undefined && id !== null)
      if (idsToDelete.length === 0) {
        this.hideDeleteConfirmationModal()
        return
      }
      executeIndividualInChunks(idsToDelete, 100, (element) => TicketApi.deleteTicket(element))
        .then(() => {
          this.hideDeleteConfirmationModal()
          this.loadTickets()
          Vue.toasted.show(this.$t('message.successMessages.deleteTicket'), { type: 'success' })
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.deleteErrors.ticket'), { type: 'error' })
        })
    },
    openAssembleListModal() {
      this.$bvModal.show('assembleListModal')
    },
    loadFields(setting: { columns: string[] }) {
      const result = this.getFields(this.dataFields, setting, true, true)
      this.fields = result?.fields
      this.selectedFields = result?.selectedFields
      this.$refs.ticketOverviewTable?.refresh()
    },
    saveFields(data: Array<{ key: string; selected: boolean }>) {
      const columns = data.filter(x => x.selected === true).map(y => y.key)
      const src = this.fromHistory ? 'list_ticket_history' : 'list_ticket_overview'
      SearchApi.saveSettings(this.accountId, columns, src).then(response => {
        const setting = response.tableSettings
        if (setting && setting.columns.length > 0) {
          this.loadFields(setting)
        }
        this.$bvModal.hide('assembleListModal')
      })
    },
    objectsAreSame(x: Record<string, unknown>, y: Record<string, unknown>): boolean {
      let objectsAreSame = true
      if (x && y) {
        for (let propertyName in x) {
          if (x[propertyName] !== y[propertyName]) {
            objectsAreSame = false
            break
          }
        }
      }
      return objectsAreSame
    },
    itemSelected(element: TicketTicket, checked: boolean) {
      if (checked && !this.selectedEntries.includes(element)) {
        this.selectedEntries.push(element)
        if (this.selectedEntries.length === this.nbrPerPage) {
          this.selectAllVisibleEntries = true
        }
      } else {
        this.selectedEntries = this.selectedEntries.filter(entry => entry.id !== element.id)
        this.selectAllEntries = false
        this.selectAllVisibleEntries = false
      }
    },
    clearCheckbox() {
      this.selectedEntries = []
      if (this.$refs.header_checkbox) {
        this.$refs.header_checkbox.checked = false
      }
      this.handleCheckboxesInsideTable(false)
    },
    handleCheckboxesInsideTable(value: boolean) {
      this.$nextTick(() => {
        if (this.$refs.ticketOverviewTable) {
          const allCheckboxesComponents = this.$refs.ticketOverviewTable.$children[1].$children
          this.handleCheckboxInSecondNode(allCheckboxesComponents, value)
          this.selectAllVisibleEntries = value
          if (value === false) {
            this.selectAllEntries = false
          }
        }
      })
    },
    showModalChangeAssignee() {
      this.newAssignee = null
      this.showChangeAssignee = true
      this.$refs.changeAssigneeModal.show()
    },
    hideChangeAssigneeModal() {
      this.showChangeAssignee = false
      if (this.$refs.changeAssigneeModal) {
        this.$refs.changeAssigneeModal.hide()
      }
      if (this.pendingBulkAction !== 'assignee') {
        this.newAssignee = null
      }
    },
    showModalChangeWatchers() {
      this.listNewWatchers = []
      this.showChangeWatchers = true
      this.$refs.changeWatchersModal.show()
    },
    hideChangeWatchersModal() {
      this.listNewWatchers = []
      this.showChangeWatchers = false
      this.$refs.changeWatchersModal.hide()
    },
    showModalChangeStatus() {
      this.newStatus = 'TICKET_STATUS_OPEN'
      this.showChangeStatus = true
      this.$nextTick(() => {
        this.$refs.changeStatusModal.show()
      })
    },
    hideChangeChangeStatus() {
      if (this.$refs.changeStatusModal) {
        this.$refs.changeStatusModal.hide()
      }
      this.showChangeStatus = false
      if (this.pendingBulkAction !== 'status') {
        this.newStatus = 'TICKET_STATUS_OPEN'
      }
    },
    showModalReportDamageInsurance() {
      this.showReportDamageInsurance = true
    },
    openInformOperatorModal() {
      this.showInformOperatorModal = true
      // Wait for v-if mount after closing another v-if modal (change status / assignee)
      setTimeout(() => {
        if (this.$refs.informOperatorModalOverview) {
          this.$refs.informOperatorModalOverview.show()
        }
      }, 200)
    },
    hideInformOperatorModal() {
      if (this.$refs.informOperatorModalOverview) {
        this.$refs.informOperatorModalOverview.hide()
      }
      this.showInformOperatorModal = false
    },
    onInformOperatorModalHide(event) {
      if (['headerclose', 'esc'].includes(event?.trigger)) {
        event.preventDefault()
        this.$refs.informOperatorDiscardModal.show()
        return
      }
      this.showInformOperatorModal = false
    },
    discardInformOperatorChanges() {
      this.$refs.informOperatorDiscardModal.hide()
      this.pendingBulkAction = ''
      this.newAssignee = null
      this.newStatus = 'TICKET_STATUS_OPEN'
      this.hideInformOperatorModal()
    },
    cancelInformOperatorClose() {
      this.$refs.informOperatorDiscardModal.hide()
    },
    proceedBulkAction(omitNotification) {
      this.hideInformOperatorModal()
      if (this.pendingBulkAction === 'status') {
        this.executeStatusBulk(omitNotification)
      } else if (this.pendingBulkAction === 'assignee') {
        this.executeAssigneeBulk(omitNotification)
      }
      this.pendingBulkAction = ''
    },
    updateTicketsStatus() {
      const listEntries = this.selectAllEntries ? this.allEntries : this.selectedEntries
      const hasOperator = listEntries.some(entry => entry.correspondences && entry.correspondences.length > 0)
      if (hasOperator) {
        this.pendingBulkAction = 'status'
        this.hideChangeChangeStatus()
        this.openInformOperatorModal()
        return
      }
      this.executeStatusBulk(false)
    },
    executeStatusBulk(omitCorrespondenceNotification) {
      executeBulkInChunks(this.selectedEntriesIds, 500, (chunk) =>
        TicketApi.changeStatusBulk(chunk, this.newStatus, omitCorrespondenceNotification)
      )
        .then(() => {
          Vue.toasted.show(this.$t('message.successMessages.ticket'), { type: 'success' })
          this.hideChangeChangeStatus()
          this.loadTickets()
        })
        .catch(e => {
          console.log(e)
          this.hideChangeChangeStatus()
          const err = e.response && e.response.data
          if (err && err.code === 2 && err.message) {
            Vue.toasted.show(err.message, { type: 'error' })
          } else {
            Vue.toasted.show(this.$t('message.savingErrors.ticket'), { type: 'error' })
          }
        })
    },
    labelEmployee(item: V2User): string {
      return item.profile.firstName + ' ' + item.profile.lastName
    },
    editTicketsAssignee() {
      const listEntries = this.selectAllEntries ? this.allEntries : this.selectedEntries
      const hasOperator = listEntries.some(entry => entry.correspondences && entry.correspondences.length > 0)
      if (hasOperator) {
        this.pendingBulkAction = 'assignee'
        this.hideChangeAssigneeModal()
        this.openInformOperatorModal()
        return
      }
      this.executeAssigneeBulk(false)
    },
    executeAssigneeBulk(omitCorrespondenceNotification) {
      const listEntries = this.selectAllEntries ? this.allEntries : this.selectedEntries
      if (this.newAssignee) {
        listEntries.forEach(element => {
          element.assignee = {
            accountId: this.newAssignee.accountId,
            userId: this.newAssignee.id
          }
        })
      }
      executeIndividualInChunks(listEntries, 1000, (element) => TicketApi.updateTicket(element, null, omitCorrespondenceNotification))
        .then(() => {
          Vue.toasted.show(this.$t('message.successMessages.ticket'), { type: 'success' })
          this.hideChangeAssigneeModal()
          this.loadTickets()
        })
        .catch(e => {
          console.log(e)
          this.hideChangeAssigneeModal()
          Vue.toasted.show(this.$t('message.savingErrors.ticket'), { type: 'error' })
        })
    },
    editTicketsWatchers() {
      const listEntries = this.selectAllEntries ? this.allEntries : this.selectedEntries
      listEntries.forEach(element => {
        const listWatchers = []
        const oldWatchers = element.watchers.map(x => x.userId)
        this.listNewWatchers.forEach(watcher => {
          if (!oldWatchers.includes(watcher.id)) {
            listWatchers.push({
              accountId: watcher.accountId,
              userId: watcher.id
            })
          }
        })
        element.watchers = element.watchers.concat(listWatchers)
      })
      executeIndividualInChunks(listEntries, 1000, (element) => TicketApi.updateTicket(element))
        .then(() => {
          Vue.toasted.show(this.$t('message.successMessages.ticket'), { type: 'success' })
          this.hideChangeWatchersModal()
          this.loadTickets()
        })
        .catch(e => {
          console.log(e)
          this.hideChangeWatchersModal()
          Vue.toasted.show(this.$t('message.savingErrors.ticket'), { type: 'error' })
        })
    },
    arrayHaveSameValues(arr1: string[], arr2: string[]): boolean {
      // Check if arrays have different lengths
      if (arr1.length !== arr2.length) {
          return false
      }
      // Sort the arrays
      arr1.sort()
      arr2.sort()
      // Compare each element of the sorted arrays
      for (let i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) {
              return false
          }
      }
      // If all elements match, arrays have the same values
      return true
    },
    async loadTickets(all = false) {
      // Cancel the previous request, if there is one
      if (this.abortController) {
        this.abortController.abort()
        this.loading = !all
      }

      // Create a new AbortController
      this.abortController = new AbortController()

      try {
        if (!all) {
          this.loading = true
          this.selectedEntries = []
          this.selectAllVisibleEntries = false
          this.selectAllEntries = false
        }

        let referenceIds = []
        if (this.searchObject.length > 0) {
          referenceIds = [...referenceIds, ...this.searchObject]
        } else if (this.searchBuilding.length > 0) {
          referenceIds = [...referenceIds, ...this.searchBuilding]
        } else if (this.searchProperty.length > 0) {
          referenceIds = [...referenceIds, ...this.searchProperty]
        }
        const params: {
          closedOnly: boolean
          includeClosed: boolean
          query: string
          types: string[]
          statuses: string[]
          priorities: string[]
          overdueOnly: boolean
          watchingOnly: boolean
          unreadByAssigneeOnly: boolean
          hasInvoiceOnly: boolean
          ownerIds: string[]
          assigneeUserIds: string[]
          creatorUserIds: string[]
          involvedContactIds: string[]
          referenceIds: string[]
          page?: number
          itemsPerPage?: number
          directReferenceIdsOnly?: boolean
        } = {
          closedOnly: this.closedTicket,
          includeClosed: this.includeClosed,
          query: this.searchText || '',
          types: this.searchType || [],
          statuses: this.draftTicket ? ['TICKET_STATUS_DRAFT'] : this.searchStatus || [],
          priorities: this.searchPriority || [],
          overdueOnly: this.defaultOverdue === 'true' ? true : this.searchDueDate === true,
          watchingOnly: this.defaultWatched === 'true' ? true : this.searchWatcher === true,
          unreadByAssigneeOnly: this.defaultNewEvent === 'true' ? true : this.searchNewEvent === true,
          hasInvoiceOnly: this.defaultUploadedInvoice === 'true' ? true : this.searchUploadedInvoice === true,
          ownerIds: this.ownerIds !== '' ? this.ownerIds.split(',') : this.searchOwner.flatMap(x => x.value) || [],
          assigneeUserIds: this.getAssigneeUserIds(),
          creatorUserIds: this.searchCreator.flatMap(x => x.value) || [],
          involvedContactIds: this.involvedPeople.map(x => x.objectID).filter(Boolean),
          referenceIds: typeof this.defaultDevice === 'string' && this.defaultDevice !== '' ? this.defaultDevice.split(',') : this.defaultDevice.length > 0 && this.arrayHaveSameValues(this.searchDevice, this.defaultDevice) ? this.defaultDevice.map(x => x.value) : this.searchDevice.length > 0 ? this.searchDevice.map(x => x.value) : referenceIds.length > 0 ? referenceIds.map(x => x.id) : this.mainReferences.concat(this.allReferences.filter(v => v.startsWith('device') || v.startsWith('room'))) || []
        }
        if (!this.draftTicket && !this.closedTicket && params.statuses.length === 0) {
          params.statuses = ['TICKET_STATUS_OPEN', 'TICKET_STATUS_IN_PROGRESS', 'TICKET_STATUS_DONE']
          if (this.fromHistory || this.includeClosed) {
            params.statuses.push('TICKET_STATUS_CLOSED')
          }
        }
        // if all tickets are to be loaded, add specific parameters
        if (all) {
          params.referenceIds = referenceIds.map(x => x.id).concat(this.mainReferences).concat(this.allReferences.filter(v => v.startsWith('device') || v.startsWith('room'))) || []
        } else {
          if (!this.isColumnView) {
            params.page = this.currentPage
            params.itemsPerPage = this.nbrPerPage
          }
        }
        if (this.mainReferences.length > 0) {
          if (this.mainReferences[0].startsWith('obj')) {
            params.directReferenceIdsOnly = false
          } else {
            params.directReferenceIdsOnly = !this.showEntireProperty
          }
        }
        const response = await TicketApi.getListMyTickets(params)
        // If the request was cancelled, don't update the messages
        if (this.abortController.signal.aborted) {
          return
        }
        if (response) {
            if (!Array.isArray(response.tickets)) {
              throw new Error('Tickets is not an array')
            }
            if (all) {
              this.allEntries = response.tickets
            } else {
              const list = response.tickets
              this.mailList = []
              if (list.filter(y => y.type === 'TICKET_TYPE_ORDER').length > 0) {
                this.loadMails(list.filter(y => y.type === 'TICKET_TYPE_ORDER').map(m => m.id))
              }

              this.totalTickets = response.totalTickets
              this.ticketList = list
              this.loadConnections(list)
              this.loadInvoices(list)
              this.$emit('ticket-length', this.totalTickets)
              this.ticketUnsortedList = list
              this.openTickets = this.ticketList.filter(
                entry => entry.status === 'TICKET_STATUS_OPEN'
              )
              this.progressTickets = this.ticketList.filter(
                entry => entry.status === 'TICKET_STATUS_IN_PROGRESS'
              )
              this.doneTickets = this.ticketList.filter(
                entry => entry.status === 'TICKET_STATUS_DONE'
              )
            }
          }
      } catch (error) {
        this.loading = true
        if (error.name === 'CanceledError') {
          console.log('Request cancelled:', error.message)
        } else {
          console.error(error)
          Vue.toasted.show(this.$t('message.loadingErrors.ticket'), { type: 'error' })
        }
      } finally {
        this.loading = false
      }
    },
    loadInvoices(list: TicketTicket[]) {
      const documentIds = [...new Set(list.map(x => x.invoiceDocumentId).filter(x => x !== ''))]
      if (documentIds.length > 0) {
        MediaApi.listDocuments(documentIds)
          .then(response => {
            this.listDocumentInvoices = response.documents
            if (this.listDocumentInvoices.length > 0) {
              const listIds = this.listDocumentInvoices.map(x => x.versions.find(y => y.version === 1)?.mediaId)
              // delete undefined and null
              const filteredIds = listIds.filter(x => x !== undefined && x !== null)
              if (filteredIds.length > 0) {
                MediaApi.getListMedia(filteredIds)
                  .then(response => {
                    for (const medium of response.media) {
                      if (!this.listMediaInvoices.find(m => m.id === medium.id)) {
                        this.listMediaInvoices.push(medium)
                      }
                    }
                  })
                  .catch(e => {
                    console.log(e)
                    Vue.toasted.show(this.$t('message.loadingErrors.documents'), { type: 'error' })
                  })
              }
            }
          })
      }
    },
    getInvoiceURL(documentId: string): string {
      const document = this.listDocumentInvoices.find(x => x.id === documentId)
      if (document) {
        const firstVersionId = document.versions.find(y => y.version === 1)?.mediaId
        if (firstVersionId) {
          const media = this.listMediaInvoices.find(x => x.id === firstVersionId)
          if (media) {
            return media.url
          }
        }
      }
      return ''
    },
    getDocumentName(documentId: string): string {
      const document = this.listDocumentInvoices.find(x => x.id === documentId)
      if (document) {
        return document.name
      }
      return '-'
    },
    isTicketReferenceInMail(ticket: TicketTicket): TicketMailEntry | null {
      if (ticket.type === 'TICKET_TYPE_ORDER') {
        return this.ticketMailMap[ticket.id] || null
      }
      return null
    },
    loadMails(referenceIds: string[]) {
      if (referenceIds.length > 0 && referenceIds.length < 400) {
        MessageApi.getDeliveryAndEngagementData(referenceIds)
          .then(response => {
            this.mailList = response.entries
          }).catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.message'), { type: 'error' })
        })
      }
    },
    getAllNetworkPartner() {
      if (this.subType && this.subType === 'owner') {
        ShareApi.listPartners(this.$store.getters['user/getAccountId'])
          .then(response => {
            if (response.targetAccountIds.length > 0) {
              this.getListEmployees(response.targetAccountIds.concat([this.$store.getters['user/getAccountId']]))
              this.isDataLoaded.assignee = true
            } else {
              this.addAvailableEmployees()
            }
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          })
      } else if (this.subType && this.subType.toLowerCase().includes('asset')) {
        ShareApi.listPartnersOfAsset(this.$store.getters['user/getAccountId'])
          .then(response => {
            if (response.partnerAccountIds.length > 0) {
              this.getListEmployees(response.partnerAccountIds.concat([this.$store.getters['user/getAccountId']]))
              this.isDataLoaded.assignee = true
            } else {
              this.addAvailableEmployees()
            }
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          })
      } else {
        ShareApi.listOwners(this.$store.getters['user/getAccountId'])
          .then(response => {
            if (response.sourceAccountIds.length > 0) {
              this.getListEmployees(response.sourceAccountIds.concat([this.$store.getters['user/getAccountId']]))
              UserApi.listAccountsByIds(response.sourceAccountIds.concat([this.$store.getters['user/getAccountId']]))
                .then(accounts => {
                  this.referencesOwners = accounts.accounts
                  this.isDataLoaded.assignee = true
                })
            } else {
              this.addAvailableEmployees()
            }
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          })
      }
    },
    getListEmployees(listIds: string[]) {
      if (listIds.length > 0) {
        TicketApi.listTicketingEnabled(listIds).then(rsp => {
          if (rsp.enabledAccountIds.length > 0) {
            UserApi.listAllEmployees(rsp.enabledAccountIds).then(response1 => {
              this.currentEmployeeList = response1.employees
              if (this.currentEmployeeList.length > 0) {
                const employeeList = this.employeeList as Array<{ accountId: string | number }>
                const currentAccountIds: number[] = this.currentEmployeeList.map(x => Number(x.accountId)).filter(x => !Number.isNaN(x))
                const employeeAccountIds: number[] = employeeList.map(x => Number(x.accountId)).filter(x => !Number.isNaN(x))
                const ids: number[] = [...new Set([...currentAccountIds, ...employeeAccountIds])]
                if (ids.length > 0) {
                  UserApi.listAccountsByIds(ids)
                    .then(accounts => {
                      this.ownerAccounts = accounts.accounts
                      this.addAvailableEmployees()
                    })
                }
              } else {
                this.addAvailableEmployees()
              }
            })
          }
        })
      }
    },
    addAvailableEmployees() {
      const array = []
      if (this.employeeList.length !== 0) {
        this.employeeList.filter(x => (x.deleted === false)).forEach((employee) => {
          const accountName = this.ownerAccounts.find(x => x.id === employee.accountId)
          array.push({
            label: (employee.profile.firstName ? employee.profile.firstName + ' ' : '') + employee.profile.lastName,
            value: employee,
            company: (accountName ? ' ' + (accountName.company ? accountName.company?.name : accountName.individual.firstName + ' ' + accountName.individual.lastName) : '')
          })
        })
      }
      if (this.currentEmployeeList.length !== 0) {
        this.currentEmployeeList.filter(x => (x.deleted === false)).forEach((employee) => {
          const accountName = this.ownerAccounts.find(x => x.id === employee.accountId)
          array.push({
            label: ((employee.profile.firstName ? employee.profile.firstName + ' ' : '') + employee.profile.lastName),
            value: employee,
            company: (accountName ? ' ' + (accountName.company ? accountName.company?.name : accountName.individual.firstName + ' ' + accountName.individual.lastName) : '')
          })
        })
      }
      const ids = array.map(o => o.value.id)
      const filtered = array.filter(({ value }, index) => !ids.includes(value.id, index + 1))
      const accountUsers = filtered.filter(x => parseInt(x.value.accountId) === this.accountId).sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1))
      const otherUsers = filtered.filter(x => parseInt(x.value.accountId) !== this.accountId).sort((a, b) => (a.company > b.company ? 1 : -1))
      this.listAllEmployees = accountUsers.concat(otherUsers)
      /**
           * Sets the value of `searchAssignee` based on the conditions.
           * If `defaultEmptyAssignee` is true, `searchAssignee` is set to an empty array.
           * If `defaultAssigne` is not empty, `searchAssignee` is filtered based on the values in `defaultAssigne`.
           * If `isOwnerModule` is true, `searchAssignee` is set to an empty array.
           * If `employeeFilteredList` is not empty, `searchAssignee` is set to an array containing the employee with `userId`.
           * Otherwise, `searchAssignee` is set to an empty array.
           */

      if (localStorage.getItem('filterAssigneeTicketOverview') || localStorage.getItem('filterClosedAssigneeTicketOverview')) {
        this.searchAssignee = []
        const list = this.$route.path.includes('tickets/closed') ? localStorage.getItem('filterClosedAssigneeTicketOverview')?.split(',') : localStorage.getItem('filterAssigneeTicketOverview')?.split(',')
        if (list) {
          list.forEach(userId => {
            if (userId === 'unassigned') {
              this.searchAssignee.push({
                accountId: '',
                active: true,
                company: '',
                label: 'unassigned',
                profile: null,
                value: 'unassigned'
              })
            } else {
              const user = this.employeeFilteredList.find(x => x.value === userId)
              if (user) {
                this.searchAssignee.push(user)
              }
            }
          })
        }
      } else if (this.defaultEmptyAssignee) {
        this.searchAssignee = []
      } else if (this.defaultAssigne !== '') {
        this.searchAssignee = this.employeeFilteredList.filter(x => this.defaultAssigne.split(',').includes(x.value))
      } else if (this.isOwnerModule) {
        this.searchAssignee = []
      } else if (this.employeeFilteredList.length > 0) {
        const user = this.employeeFilteredList.find(x => x.value === this.userId)
        if (user) {
          this.searchAssignee.push(user)
        }
      } else {
        this.searchAssignee = []
      }
      const routeQuery = this.$route.query
      const historyFilterDefaults = this.getHistoryFilterDefaults(routeQuery)
      const defaultCreatorValues = this.toFilterArray(this.defaultCreator, routeQuery.defaultCreator, historyFilterDefaults.defaultCreator)
      this.preservedCreatorFilterIds = defaultCreatorValues
      this.searchCreator = this.employeeFilteredListWithSystem.filter(x => defaultCreatorValues.includes((x?.value ?? '').toString()))
      this.isDataLoaded.assignee = true
    },
    toFilterArray(...sources) {
      const values = []
      sources.forEach(source => {
        if (!source) {
          return
        }
        const sourceValues = Array.isArray(source) ? source : source.toString().split(',')
        sourceValues.forEach(value => {
          const normalized = value !== null && value !== undefined ? value.toString().trim() : ''
          if (normalized !== '' && !values.includes(normalized)) {
            values.push(normalized)
          }
        })
      })
      return values
    },
    getHistoryFilterDefaults(routeQuery) {
      const historyFilterRaw = routeQuery?.historyFilters
      if (!historyFilterRaw) {
        return {}
      }
      try {
        const parsed = JSON.parse(historyFilterRaw)
        return parsed && typeof parsed === 'object' ? parsed : {}
      } catch (error) {
        return {}
      }
    },
    getAssigneeUserIds() {
      return this.searchAssignee
        .map(item => {
          const value = item ? item.value : ''
          if (value && typeof value === 'object') {
            return value.id || ''
          }
          return value || ''
        })
        .map(id => id === 'unassigned' ? '' : id)
    },
    connectionOptionRichness(option: GenericOption): number {
      return (option.number ? 1 : 0) + (option.numericId ? 1 : 0) + (option.title ? 1 : 0)
    },
    mergeConnectionOptions(existing: GenericOption[], options: GenericOption[]) {
      const connectionMap = new Map<string, GenericOption>()
      const mergeEntry = (incoming: GenericOption) => {
        if (!incoming?.id) {
          return
        }
        const current = connectionMap.get(incoming.id)
        if (!current) {
          connectionMap.set(incoming.id, incoming)
        } else if (this.connectionOptionRichness(incoming) > this.connectionOptionRichness(current)) {
          connectionMap.set(incoming.id, { ...current, ...incoming })
        }
      }
      options.forEach(option => mergeEntry(option))
      existing.forEach(item => mergeEntry(item))
      return [...connectionMap.values()]
    },
    getPropertiesOptions() {
      ObjectApi.propertyListFilterOptions()
        .then(response => {
          this.availablePropertyOptions = response.options
          this.allConnections.properties = this.mergeConnectionOptions(this.allConnections.properties, response.options)
          this.searchProperty = this.allConnections.properties.filter(x => this.allReferences.includes(x.id) || this.referenceIds.split(',').includes(x.id))
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
        })
        .finally(() => {
          this.isDataLoaded.property = true
        })
    },
    getBuildingsOptions() {
      ObjectApi.buildingListFilterOptions()
        .then(response => {
          this.availableBuildingOptions = response.options
          this.allConnections.buildings = this.mergeConnectionOptions(this.allConnections.buildings, response.options)
          this.searchBuilding = this.allConnections.buildings.filter(x => this.allReferences.includes(x.id) || this.referenceIds.split(',').includes(x.id))
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
        })
        .finally(() => {
          this.isDataLoaded.building = true
        })
    },
    async getObjectsOptions() {
      try {
        const response = await ObjectApi.objectListFilterOptions()
        this.availableObjectOptions = response.options
        this.allConnections.objects = this.mergeConnectionOptions(this.allConnections.objects, response.options)
        if (this.mainReferences.length > 0 && this.mainReferences.some(x => x.startsWith('obj'))) {
            const objectIds: string[] = []
            this.mainReferences.forEach(reference => {
              if (reference.startsWith('obj') && !objectIds.includes(reference) && !this.allConnections.objects?.find(x => x.id === reference)) {
                objectIds.push(reference)
              }
            })
            if (objectIds.length > 0) {
              const rsp = await ObjectApi.listObjectsByIds(objectIds)
              rsp.objects.forEach(object => {
                this.allConnections.objects.push({
                  id: object.id,
                  name: object.name || object.title || '',
                  number: object.number,
                  numericId: object.numericId,
                  ownerId: object.ownerId,
                  buildingId: object.buildingId
                })
              })
            }
          }
          this.searchObject = this.allConnections.objects.filter(x => this.allReferences.includes(x.id) || this.referenceIds.split(',').includes(x.id) || this.mainReferences.includes(x.id))
        } catch (error) {
          console.log(error)
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
        } finally {
          this.isDataLoaded.object = true
        }
    },
    searchInputText() {
      this.currentPage = 1
      this.debounceSearchInput()
    },
    applyConnectionBatchResults(values: Array<Record<string, any>>, generation: number) {
      let contactIds: string[] = []
      values.forEach(element => {
        if (element.tenancies) {
          this.allConnections.tenancies = element.tenancies
          contactIds = contactIds.concat([...new Set([].concat(...element.tenancies.map((o) => o.tenant.contactIds)))])
        } else if (element.condominiums) {
          this.allConnections.condominiums = element.condominiums
          contactIds = contactIds.concat([...new Set([].concat(...element.condominiums.map((o) => o.owner.contactIds)))])
        } else if (element.objects) {
          const objectMap = new Map()
          this.allConnections.objects.forEach(o => objectMap.set(o.id, o))
          element.objects.forEach(object => {
            objectMap.set(object.id, {
              id: object.id,
              name: object.name || object.title || '',
              number: object.number,
              numericId: object.numericId,
              ownerId: object.ownerId,
              buildingId: object.buildingId
            })
          })
          this.allConnections.objects = [...objectMap.values()]
        } else if (element.buildings) {
          const buildingMap = new Map()
          this.allConnections.buildings.forEach(b => buildingMap.set(b.id, b))
          element.buildings.forEach(building => {
            buildingMap.set(building.id, {
              id: building.id,
              name: building.name,
              number: building.number != null ? String(building.number) : undefined,
              numericId: building.numericId,
              ownerId: building.ownerId,
              objectIds: building.objectIds
            })
          })
          this.allConnections.buildings = [...buildingMap.values()]
        } else if (element.properties) {
          const propertyMap = new Map()
          this.allConnections.properties.forEach(p => propertyMap.set(p.id, p))
          element.properties.forEach(property => {
            propertyMap.set(property.id, {
              id: property.id,
              name: property.name,
              number: property.number != null ? String(property.number) : undefined,
              numericId: property.numericId,
              ownerId: property.ownerId
            })
          })
          this.allConnections.properties = [...propertyMap.values()]
        } else if (element.devices) {
          this.allConnections.devices = element.devices
          let roomIds = []
          const objectReferenceIds = []
          const buildingReferenceIds = []
          const propertyReferenceIds = []
          element.devices.forEach(device => {
            if (device.referenceId?.startsWith('obj')) {
              objectReferenceIds.push(device.referenceId)
            } else if (device.referenceId?.startsWith('building')) {
              buildingReferenceIds.push(device.referenceId)
            } else if (device.referenceId?.startsWith('prop')) {
              propertyReferenceIds.push(device.referenceId)
            }
            if (device.roomId !== '') {
              roomIds.push(device.roomId)
            }
          })
          if (objectReferenceIds.length > 0) {
            const uniqObjectIds = [...new Set(objectReferenceIds)]
            ObjectApi.listObjectsByIds(uniqObjectIds).then(responseObj => {
              if (generation !== this.loadConnectionsGeneration) {
                return
              }
              const objectMap = new Map()
              this.allConnections.objects.forEach(o => objectMap.set(o.id, o))
              ;(responseObj.objects || []).forEach(object => {
                objectMap.set(object.id, {
                  id: object.id,
                  name: object.name || object.title || '',
                  number: object.number,
                  numericId: object.numericId,
                  ownerId: object.ownerId,
                  buildingId: object.buildingId
                })
              })
              this.allConnections.objects = [...objectMap.values()]
            })
          }
          if (buildingReferenceIds.length > 0) {
            const uniqBuildingIds = [...new Set(buildingReferenceIds)]
            ObjectApi.getBuildingsListByIds(uniqBuildingIds).then(responseBuild => {
              if (generation !== this.loadConnectionsGeneration) {
                return
              }
              const buildingMap = new Map()
              this.allConnections.buildings.forEach(b => buildingMap.set(b.id, b))
              ;(responseBuild.buildings || []).forEach(building => {
                buildingMap.set(building.id, {
                  id: building.id,
                  name: building.name,
                  number: building.number != null ? String(building.number) : undefined,
                  numericId: building.numericId,
                  ownerId: building.ownerId,
                  objectIds: building.objectIds
                })
              })
              this.allConnections.buildings = [...buildingMap.values()]
            })
          }
          if (propertyReferenceIds.length > 0) {
            const uniqPropertyIds = [...new Set(propertyReferenceIds)]
            ObjectApi.getPropertyListByIds(uniqPropertyIds).then(responseProp => {
              if (generation !== this.loadConnectionsGeneration) {
                return
              }
              const propertyMap = new Map()
              this.allConnections.properties.forEach(p => propertyMap.set(p.id, p))
              ;(responseProp.properties || []).forEach(property => {
                propertyMap.set(property.id, {
                  id: property.id,
                  name: property.name,
                  number: property.number != null ? String(property.number) : undefined,
                  numericId: property.numericId,
                  ownerId: property.ownerId
                })
              })
              this.allConnections.properties = [...propertyMap.values()]
            })
          }
          if (roomIds.length > 0) {
            const uniqIds = [...new Set(roomIds)]
            if (uniqIds.length > 0) {
              RoomApi.listById(uniqIds).then(responseRoom => {
                if (generation !== this.loadConnectionsGeneration) {
                  return
                }
                const roomMap = new Map()
                this.allConnections.rooms.forEach(r => roomMap.set(r.id, r))
                responseRoom.rooms.forEach(r => roomMap.set(r.id, r))
                this.allConnections.rooms = [...roomMap.values()]
              })
            }
          }
        } else if (element.requests) {
          this.allConnections.requests = element.requests
          contactIds = contactIds.concat([...new Set([].concat(...element.requests.map((req) => req.requesters[0]?.contactId)))])
        } else if (element.rooms) {
          const roomMap = new Map()
          this.allConnections.rooms.forEach(r => roomMap.set(r.id, r))
          element.rooms.forEach(r => roomMap.set(r.id, r))
          this.allConnections.rooms = [...roomMap.values()]
        } else if (element.mortgages) {
          this.allConnections.mortgages = element.mortgages
        } else if (element.insurances) {
          this.allConnections.insurances = element.insurances
        } else if (element.persons || element.companies) {
          this.allConnections.contacts = ([...(element.persons || []), ...(element.companies || [])] as GenericOption[])
        }
      })
      if (contactIds.length > 0) {
        const contactIdSet = new Set(contactIds)
        ContactApi.contactResolve(contactIds)
          .then(responseCon => {
            if (generation !== this.loadConnectionsGeneration) {
              return
            }
            const contactMap = new Map()
            this.listContacts.forEach(c => contactMap.set(c.id, c))
            ;([...(responseCon.persons || []), ...(responseCon.companies || [])] as Contact[])
              .filter(c => contactIdSet.has(c.id))
              .forEach(c => contactMap.set(c.id, c))
            this.listContacts = [...contactMap.values()]
          })
      }
    },
    async fetchMissingConnections(tickets: TicketTicket[], generation: number) {
      const missingIds = new Set<string>()
      tickets.forEach(element => {
        element.references.forEach(ref => {
          if (ref.id && this.getConnection(ref.id) === undefined) {
            missingIds.add(ref.id)
          }
          ;(ref.relatedIds || []).forEach((relatedId: string) => {
            if (relatedId && this.getConnection(relatedId) === undefined) {
              missingIds.add(relatedId)
            }
          })
        })
      })
      if (missingIds.size === 0) {
        return
      }

      const fallbackResults: Array<Record<string, any>> = []
      const missingObj = [...missingIds].filter(id => id.startsWith('obj'))
      if (missingObj.length > 0) {
        const objects = (await executeIndividualInChunks(missingObj, 20, id =>
          ObjectApi.getObject(id).then(response => response.object).catch(() => null)
        )).filter(object => object != null)
        if (generation !== this.loadConnectionsGeneration) {
          return
        }
        if (objects.length > 0) {
          fallbackResults.push({ objects })
        }
      }

      const missingBuilding = [...missingIds].filter(id => id.startsWith('building'))
      if (missingBuilding.length > 0) {
        const buildings = (await executeIndividualInChunks(missingBuilding, 20, id =>
          ObjectApi.getBuilding(id).then(response => response.building).catch(() => null)
        )).filter(building => building != null)
        if (generation !== this.loadConnectionsGeneration) {
          return
        }
        if (buildings.length > 0) {
          fallbackResults.push({ buildings })
        }
      }

      const missingProp = [...missingIds].filter(id => id.startsWith('prop'))
      if (missingProp.length > 0) {
        const propertyResponses = await executeBulkInChunks<any>(missingProp, 100, chunk =>
          ObjectApi.getPropertyListByIds(chunk)
        )
        if (generation !== this.loadConnectionsGeneration) {
          return
        }
        const properties = propertyResponses.flatMap(response => response.properties || [])
        if (properties.length > 0) {
          fallbackResults.push({ properties })
        }
      }

      if (fallbackResults.length > 0) {
        this.applyConnectionBatchResults(fallbackResults, generation)
      }
    },
    loadConnections(tickets: TicketTicket[]) {
      const generation = ++this.loadConnectionsGeneration
      const setCondo = new Set<string>()
      const setTenancy = new Set<string>()
      const setObj = new Set<string>()
      const setBuilding = new Set<string>()
      const setProp = new Set<string>()
      const setContact = new Set<string>()
      const setDevice = new Set<string>()
      const setRequest = new Set<string>()
      const setRoom = new Set<string>()
      const setMortgage = new Set<string>()
      const setInsurance = new Set<string>()

      tickets.forEach(element => {
        for (let index = 0; index < element.references.length; index++) {
          const ref = element.references[index]
          if (ref.id.startsWith('condominium')) {
            setCondo.add(ref.id)
          } else if (ref.id.startsWith('tenancy')) {
            setTenancy.add(ref.id)
          } else if (ref.id.startsWith('obj')) {
            setObj.add(ref.id)
          } else if (ref.id.startsWith('building')) {
            setBuilding.add(ref.id)
          } else if (ref.id.startsWith('prop')) {
            setProp.add(ref.id)
          } else if (ref.id.startsWith('contact')) {
            setContact.add(ref.id)
          } else if (ref.id.startsWith('device')) {
            setDevice.add(ref.id)
          } else if (ref.id.startsWith('request')) {
            setRequest.add(ref.id)
          } else if (ref.id.startsWith('room')) {
            setRoom.add(ref.id)
          } else if (ref.id.startsWith('mortgage')) {
            setMortgage.add(ref.id)
          } else if (ref.id.startsWith('ins')) {
            setInsurance.add(ref.id)
          }
          ;(ref.relatedIds || []).forEach((relatedId: string) => {
            if (relatedId.startsWith('obj')) {
              setObj.add(relatedId)
            } else if (relatedId.startsWith('building')) {
              setBuilding.add(relatedId)
            } else if (relatedId.startsWith('prop')) {
              setProp.add(relatedId)
            } else if (relatedId.startsWith('room')) {
              setRoom.add(relatedId)
            }
          })
        }
      })

      const arrCondo = [...setCondo]
      const arrTenancy = [...setTenancy]
      const arrObj = [...setObj]
      const arrBuilding = [...setBuilding]
      const arrProp = [...setProp]
      const arrContact = [...setContact]
      const arrDevice = [...setDevice]
      const arrRequest = [...setRequest]
      const arrRoom = [...setRoom]
      const arrMortgage = [...setMortgage]
      const arrInsurance = [...setInsurance]
      const promises: Array<Promise<Record<string, any>>> = []
      if (arrCondo.length > 0) {
        promises.push(ObjectApi.getCondominiumByIds(arrCondo))
      }
      if (arrTenancy.length > 0) {
        promises.push(ObjectApi.getTenanciesByIds(arrTenancy))
      }
      if (arrObj.length > 0) {
        promises.push(
          executeBulkInChunks(arrObj, 100, chunk => ObjectApi.listObjectsByIds(chunk))
            .then(responses => ({ objects: responses.flatMap(response => response.objects || []) }))
        )
      }
      if (arrBuilding.length > 0) {
        promises.push(
          executeBulkInChunks<any>(arrBuilding, 100, chunk => ObjectApi.getBuildingsListByIds(chunk))
            .then(responses => ({ buildings: responses.flatMap(response => response.buildings || []) }))
        )
      }
      if (arrProp.length > 0) {
        promises.push(
          executeBulkInChunks<any>(arrProp, 100, chunk => ObjectApi.getPropertyListByIds(chunk))
            .then(responses => ({ properties: responses.flatMap(response => response.properties || []) }))
        )
      }
      if (arrContact.length > 0) {
        promises.push(ContactApi.contactResolve(arrContact))
      }
      if (arrDevice.length > 0) {
        promises.push(ObjectApi.listDevicesByIds(arrDevice))
      }
      if (arrRequest.length > 0) {
        promises.push(RequestApi.listByIds(arrRequest))
      }
      if (arrRoom.length > 0) {
        promises.push(RoomApi.listById(arrRoom))
      }
      if (arrMortgage.length > 0) {
        promises.push(ObjectApi.getMortgagesByIds(arrMortgage))
      }
      if (arrInsurance.length > 0) {
        promises.push(ObjectApi.getInsurancesByIds(arrInsurance))
      }

      Promise.all(promises)
        .then(async values => {
          if (generation !== this.loadConnectionsGeneration) {
            return
          }
          this.applyConnectionBatchResults(values, generation)
          await this.fetchMissingConnections(tickets, generation)
        })
        .catch(e => {
          if (generation !== this.loadConnectionsGeneration) {
            return
          }
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
        })
        .finally(() => {
          if (generation !== this.loadConnectionsGeneration) {
            return
          }
          this.loading = false
        })
    },
    customLabelEmployee(item: EmployeeLabelOption): string {
      if ('option' in item) {
        if (item.option?.label === 'system') {
          return String(this.$t('message.ticketOverview.ticket.createdBySystem'))
        } else {
          return item.option?.label + (item.option?.company ? (' -' + item.option.company) : '')
        }
      } else {
        if (item.label === 'system') {
          return String(this.$t('message.ticketOverview.ticket.createdBySystem'))
        } else {
          return item.label + (item.company ? (' -' + item.company) : '')
        }
      }
    },
    customLabelEstate(item: { company?: string }): string {
      return item.company
    },
    customLabelOperator(item: { name?: string }): string {
      return item.name
    },
    customLabelType(item: string): string {
      return String(this.$t('message.ticketOverview.ticket.type.' + item))
    },
    customLabelPriority(item: string): string {
      return String(this.$t('message.ticketOverview.ticket.priority.' + item))
    },
    customLabelStatus(item: string): string {
      return String(this.$t('message.ticketOverview.status.' + item))
    },
    customLabelDevice(item: { value: string | null; label?: string }): string {
      if (item.value === null) {
        return String(this.$t('message.generic.unassigned'))
      }
      return item.label || ''
    },
    onTicketDragStart(evt: DragEvent, ticket: TicketTicket, fromColumn: string) {
      this.dragging = true
      this.draggingTicket = ticket
      this.draggingCollumn = 'status-' + fromColumn
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('text/plain', ticket.id)
    },
    onTicketDragEnd() {
      this.dragging = false
      this.draggingOver = null
      this.draggingTicket = null
    },
    onColumnDragOver(evt: DragEvent, column: string) {
      this.draggingOver = column
    },
    onColumnDragLeave(evt: DragEvent, column: string) {
      const currentTarget = evt.currentTarget as Node | null
      const relatedTarget = evt.relatedTarget as Node | null
      if (!currentTarget || !currentTarget.contains(relatedTarget)) {
        if (this.draggingOver === column) {
          this.draggingOver = null
        }
      }
    },
    onColumnDrop(evt: DragEvent, toColumn: string) {
      if (!this.draggingTicket) return
      const fromColumnId = this.draggingCollumn
      const toColumnId = 'status-' + toColumn
      this.dragging = false
      this.draggingOver = null
      if (fromColumnId !== toColumnId) {
        const newStatus = 'TICKET_STATUS_' + toColumn.toUpperCase()
        const ticketToUpdate = this.ticketList.find(x => x.id === this.draggingTicket.id)
        if (ticketToUpdate) {
          ticketToUpdate.status = newStatus
          this.statusChanged()
          let updateMask = null
          if (!this.isAuthenticated) {
            updateMask = { paths: ['Id', 'Status'] }
          }
          TicketApi.updateTicket(ticketToUpdate, updateMask)
            .catch(e => {
              console.log(e)
              Vue.toasted.show(this.$t('message.savingErrors.ticket'), { type: 'error' })
            })
        }
      }
      this.draggingTicket = null
    },
    showDetail(item: TicketTicket, index: number, event: MouseEvent) {
      if (item.status === 'TICKET_STATUS_DRAFT') {
        if (item.type === 'TICKET_TYPE_ORDER') {
          this.openDraftOrder(item)
        } else {
          this.editTicket(item)
        }
      } else {
        this.openDetail(item, event)
      }
    },
    showDetailMiddle(item: TicketTicket, index: number, event: MouseEvent) {
      this.openMiddleDetail(item, event)
    },
    editTicket(item: TicketTicket) {
      if (this.isOwnerModule) {
        this.$router.push({
          name: 'OwnerTicketEdition',
          params: { id: item.key }
        })
      } else if (this.isAdminModule) {
        this.$router.push({
          name: 'AdminTicketEdition',
          params: { id: item.key }
        })
      } else if (this.isAssetModule) {
        this.$router.push({
          name: 'AssetTicketEdition',
          params: { id: item.key }
        })
      } else if (this.isAccountingModule) {
        this.$router.push({
          name: 'AccountingTicketEdition',
          params: { id: item.key }
        })
      } else {
        this.$router.push({
          name: 'MarketingTicketEdition',
          params: { id: item.key }
        })
      }
    },
    async openDraftOrder(item: TicketTicket) {
      const currentRoute = { name: this.$router.currentRoute.name, params: this.$router.currentRoute.params, query: this.$router.currentRoute.query }
      localStorage.setItem('LS_ROUTE_KEY', JSON.stringify(currentRoute))

      const refs = item.references || []
      const propertyIds: string[] = []
      const buildingIds: string[] = []
      const objectIds: string[] = []
      const tenancyIds: string[] = []
      const condoOwnerIds: string[] = []
      const deviceIds: string[] = []
      const contactIds: string[] = []
      const roomIds: string[] = []
      const categorizeId = (id: string) => {
        switch (true) {
          case id.startsWith('prop_'):
            if (!propertyIds.includes(id)) propertyIds.push(id)
            break
          case id.startsWith('building_'):
            if (!buildingIds.includes(id)) buildingIds.push(id)
            break
          case id.startsWith('obj_'):
            if (!objectIds.includes(id)) objectIds.push(id)
            break
          case id.startsWith('tenancy_'):
            if (!tenancyIds.includes(id)) tenancyIds.push(id)
            break
          case id.startsWith('condominium_'):
            if (!condoOwnerIds.includes(id)) condoOwnerIds.push(id)
            break
          case id.startsWith('device_'):
            if (!deviceIds.includes(id)) deviceIds.push(id)
            break
          case id.startsWith('contact_'):
            if (!contactIds.includes(id)) contactIds.push(id)
            break
          case id.startsWith('room_'):
            if (!roomIds.includes(id)) roomIds.push(id)
            break
        }
      }
      refs.forEach((ref) => {
        categorizeId(ref.id)
        if (ref.relatedIds) {
          ref.relatedIds.forEach(id => categorizeId(id))
        }
      })

      const query: Record<string, string> = {
        draftTicketId: item.id,
        source: 'draftOrder'
      }
      if (propertyIds.length) query.propertyIds = propertyIds.join(',')
      if (buildingIds.length) query.buildingIds = buildingIds.join(',')
      if (objectIds.length) query.objectIds = objectIds.join(',')
      if (tenancyIds.length) query.tenancyIds = tenancyIds.join(',')
      if (condoOwnerIds.length) query.condoOwnerIds = condoOwnerIds.join(',')
      if (deviceIds.length) query.deviceIds = deviceIds.join(',')
      if (contactIds.length) query.contactIds = contactIds.join(',')
      if (roomIds.length) query.roomIds = roomIds.join(',')

      try {
        const mailboxIds = this.getMailboxesForUserId(this.userId, false).map(mailbox => mailbox.id)
        const response = await MessageApi.listMailsByReferenceIds([item.id], 'FILTER_FOLDER_ALL', mailboxIds, 1, 1)
        const mails = (response.mails || []).filter(x => x.mailType !== 'MAIL_TYPE_TICKET_NOTIFICATION')
        if (mails.length > 0) {
          query.source = 'email'
          query.emailsData = JSON.stringify({ id: mails[0].id, referenceIds: mails[0].referenceIds })
        }
      } catch (e) {
        console.log(e)
      }

      let routeName = ''
      if (this.isOwnerModule) {
        routeName = 'OwnerCreateOrderView'
      } else if (this.isAdminModule) {
        routeName = 'AdminCreateOrderView'
      } else if (this.isAssetModule) {
        routeName = 'AssetCreateOrderView'
      } else if (this.isAccountingModule) {
        routeName = 'AccountingCreateOrderView'
      } else {
        routeName = 'MarketingCreateOrderView'
      }
      this.$router.push({ name: routeName, query: query }, () => {})
    },
    routeToDetail() {
      const ticket = this.selectedTicket
      if (this.isOwnerModule) {
        this.$router.push({
          name: 'OwnerTicketDetailsView',
          params: { id: ticket.key }
        }, () => {
        })
      } else if (this.isAdminModule) {
        this.$router.push({
          name: 'AdminTicketDetailsView',
          params: { id: ticket.key }
        }, () => {
        })
      } else if (this.isAssetModule) {
        this.$router.push({
          name: 'AssetTicketDetailsView',
          params: { id: ticket.key }
        }, () => {
        })
      } else if (this.isAccountingModule) {
        this.$router.push({
          name: 'AccountingTicketDetailsView',
          params: { id: ticket.key }
        }, () => {
        })
      } else {
        this.$router.push({
          name: 'MarketingTicketDetailsView',
          params: { id: ticket.key }
        }, () => {
        })
      }
    },
    openDetail(ticket, e) {
      if (e.srcElement.classList.contains('external-link')) {
        return false
      } else {
        this.selectedTicket = ticket
        if (this.linkEmail) {
          this.$refs.confirmationModalLinkTicket.show()
        } else {
          this.routeToDetail()
        }
      }
    },
    openMiddleDetail(ticket, e) {
      if (e.srcElement.classList.contains('external-link')) {
        return false
      } else {
      let routeData: { href: string } = { href: '' }
        if (this.isOwnerModule) {
          routeData = this.$router.resolve({
            name: 'OwnerTicketDetailsView',
            params: { id: ticket.key }
          }, () => {
          })
        } else if (this.isAdminModule) {
          routeData = this.$router.resolve({
            name: 'AdminTicketDetailsView',
            params: { id: ticket.key }
          }, () => {
          })
        } else if (this.isAssetModule) {
          routeData = this.$router.resolve({
            name: 'AssetTicketDetailsView',
            params: { id: ticket.key }
          }, () => {
          })
        } else if (this.isAccountingModule) {
          routeData = this.$router.resolve({
            name: 'AccountingTicketDetailsView',
            params: { id: ticket.key }
          }, () => {
          })
        } else {
          routeData = this.$router.resolve({
            name: 'MarketingTicketDetailsView',
            params: { id: ticket.key }
          }, () => {
          })
        }
        window.open(routeData.href, '_blank')
      }
    },
    linkTickets() {
      this.disabledLinkBtn = true
      MessageApi.setReferenceIds([this.linkEmail], [this.selectedTicket.id].concat(this.email.referenceIds.filter(x => !x.includes('ticket_'))))
        .then(() => {
          this.loading = false
          Vue.toasted.show(this.$t('message.successMessages.emailLinked'), { type: 'success' })
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.savingErrors.reference'), { type: 'error' })
        })
        .finally(() => {
          this.disabledLinkBtn = false
          this.$refs.confirmationModalLinkTicket.hide()
          this.routeToDetail()
        })
    },
    statusChanged() {
      this.openTickets = this.ticketList.filter(
        entry => entry.status === 'TICKET_STATUS_OPEN'
      )
      this.progressTickets = this.ticketList.filter(
        entry => entry.status === 'TICKET_STATUS_IN_PROGRESS'
      )
      this.doneTickets = this.ticketList.filter(
        entry => entry.status === 'TICKET_STATUS_DONE'
      )
    },
    getConnectionName(ticket) {
      const names = []
      if (ticket?.references.length > 0) {
        ticket?.references.forEach(ref => {
          const id = ref.id
          if (id.startsWith('condominium')) {
            const connection = this.getConnection(id)
            if (connection?.owner?.contactIds.length > 0) {
              connection.owner.contactIds.forEach(contact => {
                names.push((this.getContactName(contact))?.toLowerCase())
              })
            }
          } else if (id.startsWith('tenancy')) {
            const connection = this.getConnection(id)
            if (connection?.tenant?.contactIds.length > 0) {
              connection.tenant.contactIds.forEach(contact => {
                names.push((this.getContactName(contact))?.toLowerCase())
              })
            }
          } else if (id.startsWith('obj')) {
            const connection = this.getConnection(id)
            if (connection) {
              names.push((connection.name !== '' ? connection.name : connection.number ? connection.number : connection.numericId)?.toLowerCase())
            }
          } else if (id.startsWith('building')) {
            names.push((this.getConnection(id)?.name)?.toLowerCase())
          } else if (id.startsWith('prop')) {
            names.push((this.getConnection(id)?.name)?.toLowerCase())
          } else if (id.startsWith('contact')) {
            names.push((this.getConnection(id)?.name)?.toLowerCase())
          } else if (id.startsWith('device')) {
            names.push(this.getConnection(id) ? this.$t('message.onBoarding.devices.typeValues.' + (this.getConnection(id)?.type))?.toLowerCase() : '')
          } else if (id.startsWith('request')) {
            const connection = this.getConnection(id)
            if (connection?.requesters.length > 0) {
              names.push((this.getContactName(connection.requesters[0].contactId))?.toLowerCase())
            }
          }
        })
      }
      return names
    },
    changeFilter(val) {
      this.$router.push({
        name: 'TicketOverview',
        query: { filter: val }
      })
    },
    initFilter() {
      this.searchText = ''
      this.searchCreator = []
      this.searchDueDate = false
      this.searchWatcher = false
      this.searchNewEvent = false
      this.searchUploadedInvoice = false
      this.emptyAssignee = false
      this.searchAssignee = []
      this.searchPriority = []
      this.searchType = []
      this.searchStatus = []
      this.searchDevice = []
      this.searchProperty = []
      this.searchBuilding = []
      this.searchObject = []
      this.searchOwner = []
      this.involvedPeople = []
      this.loadTickets()
    },
    changeTicketUrl() {
      this.readyForLoad = false
      let checkRoute = ''
      const query: Record<string, string> = {}
      let queryHistoryFilters: Record<string, string> = {}
      if (this.mainReferences.length === 0 && !this.$route.name.includes('ActivitiesTicketView')) {
        if (this.isOwnerModule) {
          checkRoute = this.closedTicket ? 'OwnerClosedTicketOverview' : this.draftTicket ? 'OwnerDraftTicketOverview' : 'OwnerTicketOverview'
        } else if (this.isMarketingModule) {
          checkRoute = this.closedTicket ? 'MarketingClosedTicketOverview' : this.draftTicket ? 'MarketingDraftTicketOverview' : 'MarketingTicketOverview'
        } else if (this.isAdminModule) {
          checkRoute = this.closedTicket ? 'AdminClosedTicketOverview' : this.draftTicket ? 'AdminDraftTicketOverview' : 'AdminTicketOverview'
        } else if (this.isAccountingModule) {
          checkRoute = this.closedTicket ? 'AccountingClosedTicketOverview' : this.draftTicket ? 'AccountingDraftTicketOverview' : 'AccountingTicketOverview'
        } else if (this.isAssetModule) {
          checkRoute = this.closedTicket ? 'AssetClosedTicketOverview' : this.draftTicket ? 'AssetDraftTicketOverview' : 'AssetTicketOverview'
        }
      } else if (this.$route.name.includes('ActivitiesTicketView')) {
        if (this.isOwnerModule) {
          checkRoute = 'OwnerActivitiesTicketView'
        } else if (this.isMarketingModule) {
          checkRoute = 'MarketingActivitiesTicketView'
        } else if (this.isAdminModule) {
          checkRoute = 'AdminActivitiesTicketView'
        } else if (this.isAccountingModule) {
          checkRoute = 'AccountingActivitiesTicketView'
        } else if (this.isAssetModule) {
          checkRoute = 'AssetActivitiesTicketView'
        }
      } else if (this.prevRoute) {
        checkRoute = this.prevRoute.name
      }
      if (!this.isFirstLoad) {
          if (this.searchAssignee.length > 0) {
            query.defaultAssigne = this.searchAssignee.filter(z => z && 'value' in z).map(x => x.value).join(',')
          } else {
            query.defaultEmptyAssignee = 'true'
          }
          if (this.searchText !== '') {
            query.defaultText = this.searchText
          }
          if (this.searchType.length > 0) {
            query.defaultType = this.searchType.join(',')
          }
          if (this.searchStatus.length > 0) {
            query.defaultStatus = this.searchStatus.join(',')
          }
          if (this.searchDevice.length > 0) {
            query.defaultDevice = this.searchDevice.map(x => x.value).join(',')
          }
          const creatorFilterIds = this.searchCreator.length > 0
            ? this.searchCreator.map(x => (x?.value ?? '').toString()).filter(Boolean)
            : (this.hasLoadedInitialTickets ? [] : this.preservedCreatorFilterIds)
          if (creatorFilterIds.length > 0) {
            query.defaultCreator = creatorFilterIds.join(',')
          }
          if (this.involvedPeople.length > 0) {
            query.defaultOperator = this.involvedPeople.map(x => x.objectID).join(',')
          }
          if (this.searchPriority.length > 0) {
            query.defaultPriority = this.searchPriority.join(',')
          }
          if (this.searchDueDate) {
            query.defaultOverdue = this.searchDueDate ? 'true' : 'false'
          }
          if (this.searchWatcher) {
            query.defaultWatched = this.searchWatcher ? 'true' : 'false'
          }
          if (this.searchNewEvent) {
            query.defaultNewEvent = this.searchNewEvent ? 'true' : 'false'
          }
          if (this.searchUploadedInvoice) {
            query.defaultUploadedInvoice = this.searchUploadedInvoice ? 'true' : 'false'
          }
          if (this.linkEmail !== null) {
            query.linkEmail = this.linkEmail
          }
          if (this.nameLinked !== null) {
            query.nameLinked = this.nameLinked
          }
          if (this.searchOwner.length > 0) {
            query.ownerIds = this.searchOwner.map(x => x.value).join(',')
          }
          const references = this.searchProperty.concat(this.searchBuilding).concat(this.searchObject)
          if (references.length > 0) {
            query.referenceIds = references.map(x => x.id).join(',') || []
          }
          if (this.mainReferences.length > 0) {
            queryHistoryFilters = {
              ...this.prevRoute?.query,
              historyFilters: JSON.stringify(query)
            }
          }
      }
      // console.log('route query :', JSON.stringify(this.$route.query))
      // console.log('history query :', JSON.stringify(queryHistoryFilters))
      if (((this.mainReferences.length === 0 && JSON.stringify(this.$route.query) !== JSON.stringify(query)) || (this.mainReferences.length > 0 && JSON.stringify(this.$route.query) !== JSON.stringify(queryHistoryFilters))) && !this.isFirstLoad) {
        this.$router.replace({
          name: checkRoute,
          query: this.mainReferences.length > 0 ? queryHistoryFilters : query
        })
      }
      this.readyForLoad = true
    },
    setColumnView(value) {
      this.isColumnView = value
    },
    setRoomId(source: string, id: string): void {
      if (source === 'building') {
        localStorage.setItem('expandBuildingRoomId', id)
      } else if (source === 'object') {
        localStorage.setItem('expandObjectRoomId', id)
      }
    },
    navigateToRoom(room, roomRefId: string, newTab = false): void {
      if (!room) return
      const source = room.referenceId?.startsWith('building') ? 'building' : 'object'
      const route = this.redirectToDetail(room, room.referenceId, 'objects')
      if (!route || (route.params && !route.params.id)) return
      this.setRoomId(source, roomRefId)
      if (newTab) {
        const resolved = this.$router.resolve(route)
        window.open(resolved.href, '_blank')
      } else {
        this.$router.push(route)
      }
    },
    redirectToDetail(item, objectId, view) {
      let buildingId = null
      if (item) {
        if (item.id.startsWith('room')) {
          if (item.referenceId.startsWith('obj')) {
            buildingId = item.buildingId || this.allConnections.buildings.find(y => y.objectIds?.includes(item.referenceId))?.id || null
          } else if (item.referenceId.startsWith('building')) {
            return this.redirectToDetailPage(item, 'building')
          }
        } else {
          buildingId = item.buildingId || this.allConnections.buildings.find(y => y.objectIds?.includes(item.objectId))?.id || null
        }
      }
      if (buildingId) {
        if (this.isOwnerModule) {
          return {
            name: 'OwnerBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAdminModule) {
          return {
            name: 'AdminBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAssetModule) {
          return {
            name: 'AssetBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAccountingModule) {
          return {
            name: 'AccountingBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        }
      }
      return ''
    },
    _updateScrollers() {
      const refs = ['openScroller', 'progressScroller', 'doneScroller']
      refs.forEach(refName => {
        const scroller = this.$refs[refName]?.$refs?.scroller
        if (scroller) scroller.updateVisibleItems(false, false)
      })
    },
    forceScrollerUpdate() {
      this.$nextTick(() => {
        this._updateScrollers()
      })
    },
    _onPageScrollForScrollers() {
      if (this._scrollerRafId) return
      this._scrollerRafId = requestAnimationFrame(() => {
        this._scrollerRafId = null
        this._updateScrollers()
      })
    }
  }
})
</script>

<style lang="scss" scoped>

.column-heading {
  background-color: $color-bg-grey;
}

.ticket-item {
  padding-bottom: 1px;
}

.column-container {
  background-color: $color-bg-grey;
}

.dragging-border {
  border: 2px dashed $color-primary;
  border-radius: 0.25rem;
  min-height: 100px;
}
.as-button :deep(.btn-secondary) {
  min-height: 31px;
  height: auto;
  padding-left: 0;
  padding-right: 0;
}
.dropdownOptionHover:hover {
  background-color: #e9ecef;
  color: #0055b7 !important;
  text-decoration: underline !important;
  cursor: pointer;
  :deep(.dropdown-item) {
    color: #0055b7 !important;
    }
}
@media (max-width: 991px) {
  #status-done {
    margin-bottom: 150px !important;
  }
}
</style>
